<app-patient-search
  class="mb-10"
  [search]="searchCriteria"
  [list]="patientList"
  [refreshTime]="refreshTime"
  [hideAfter]="hidePatientSearch"
  (onActionClick)="patientOnSelect($event)"
  [mergedPrimary]="patientForm==true?false:true"
></app-patient-search>
<div class="registration_nav" *ngIf="patientForm"></div>
<div class="patient-detail fixed-height" >
  <div class="flex">
    <div class="col-8">
      <div *ngIf="patientInfoDisplay" style="width: 180vh;">
        <img
          class="user-img"
          [src]="patientImage ? patientImage : './assets/images/user.png'"
        />
        <label class="patient-name-label"> {{ patientInfoDisplay }}</label>&nbsp;
        <img
          class="user-img"
          [src]="isVip ? './assets/images/email-icons/vip-icon.png':null"
          *ngIf="isVip"
          style="height: 28px;"
        />
        <img
        class="user-img"
        [src]="isNoteVisible ? './assets/images/chat-alert-light.png':null"
        [matTooltip]="isNoteVisible"
        *ngIf="isNoteVisible"
         style="height: 28px;"
        />
        </div>          
      <div *ngIf="!patientInfoDisplay">
        <label class="patient-name-label">{{
          "RegistrationPage.noPatient" | translate
        }}</label>
      </div>
    </div>
    <div class="col-4 right">
      <button
        id="Add Patient"
        (click)="resetRegisterationForm()"
        class="btnCyan"
        mat-mini-fab
        *ngIf="!patientForm && !patientId"
        matTooltip="{{ 'payerInfo.addPatient' | translate }}">
        <mat-icon>add</mat-icon>
      </button>
      <button
        id="Edit Patient"
        (click)="patientForm = !patientForm; editPatientClicked()"
        class="btnCyan"
        mat-mini-fab
        matTooltip="{{ 'payerInfo.editPatient' | translate }}"
        *ngIf="!patientForm && patientId">
        <mat-icon>edit</mat-icon
        >
      </button>
    </div>
  </div>
</div>

<div *ngIf="patientForm" id="registration">
  <form
    [formGroup]="formRegistration"
    #patientRegForm="ngForm"
    novalidate
    class="mt-10"
    attr.data-automation-attribute="formUserPersonalDetails"
  >
    <div style="position: relative; display: inline-block; width: 100%;">
  <mat-tab-group class="tabGroupPersonalDetails mt-10">
    <mat-tab class="tabSubPersonalDetails">
      <ng-template mat-tab-label>
        {{ "RegistrationPage.details" | translate }}
      </ng-template>
    <div class="form-container">
      <div class="flex">
        <div class="col-2">
          <div class="center">
            <img
              [src]="'assets/images/noavatar_new.png'"
              alt="Patient"
              title="Patient"
              *ngIf="!patientImage"
              class="patient-avatar"
              (click)="uploadImageDialog()"
              attr.data-automation-attribute="imgDefaultUser"
            />
            <img
              [src]="patientImage"
              *ngIf="patientImage"
              alt="Patient"
              title="Patient"
              class="patient-avatarupload"
              (click)="uploadImageDialogForEdit(patientImage)"
              attr.data-automation-attribute="imgDefaultUser"
            />
          </div>
        </div>
        <div class="col-9">
          <!-- <div class="section-born">
            <mat-checkbox formControlName="isDeceased" [required]="mandatoryField.isDeceased" (change)="deceasedRemove($event)">
              {{ "RegistrationPage.isDeceased" | translate }}
            </mat-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
            <mat-checkbox
              formControlName="isNewborn"
              (change)="onNewbornChange($event.checked)"
              >{{ "RegistrationPage.newBorn" | translate }}</mat-checkbox
            >&nbsp;&nbsp;&nbsp;&nbsp;
            <mat-checkbox
              formControlName="isInactive"
             
              >{{ "RegistrationPage.inActive" | translate }}</mat-checkbox
            >
          </div> -->
          <!-- <mat-grid-list cols="12" rowHeight="50px">
            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "RegistrationPage.primaryID" | translate
                }}</mat-label>
                <mat-select
                  [required]="mandatoryField.identificationType"
                  attr.data-automation-attribute="encounterDoctor"
                  formControlName="primaryId"
                  [(ngModel)]="primaryIdNewValue"
                  (selectionChange)="primaryIdentificationOnChange($event ,true)"
                  [readonly]="isDisabled"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="primaryIdSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>

                  <mat-option
                    *ngFor="let option of primaryIdFilteredList"
                    [value]="option.code"
                  >
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label
                  >{{ "RegistrationPage.primaryDocNo" | translate }}
                </mat-label>
                <input
                  [pattern]="primaryIdRegex"
                  matInput
                  formControlName="primaryNumber"
                  [maxlength]="maxIdentificationLength"
                  [minlength]="minIdentificationLength"
                  [required]="mandatoryField.identificationNo"
                  [placeholder]="'RegistrationPage.primaryDocNo' | translate"
                  attr.data-automation-attribute="txtPrimaryIDDesc"
                  (keyup)="primaryNumberOnKeyUp($event.target.value)"
                  pattern="[a-zA-Z0-9]+"
                  (focusout)="onFocusOutEvent($event.target.value)"
                />
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label
                  >{{ "RegistrationPage.expiryDate" | translate }}
                </mat-label>
                <input
                  [required]="isexpiryDate"
                  matInput
                  [min]="now"
                  [max]="maxExpiry"
                  [matDatepicker]="picker2"
                  [placeholder]="'RegistrationPage.expiryDate' | translate"
                  attr.data-automation-attribute="dateExpiry"
                  name="acb"
                  [disabled]="!isexpiryDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="3">
              <app-master-form-field
                [isRequired]="mandatoryField.issuingCountry"
                [label]="'RegistrationPage.idCountry' | translate"
                [masterName]="masterAPI.COUNTRY_MASTER"
                [formControlName]="'issuedCountryPrimary'"
                [defaultValue]="selectedPatient ? selectedPatient.idIssueCountry : ''"
                [parentForm]="formRegistration"
                [isSubmitted]="patientRegForm.submitted"
              >
              </app-master-form-field>
            </mat-grid-tile>
          </mat-grid-list> -->
          <div class="table-container">
            <table mat-table [dataSource]="identificationList" class="mat-elevation-z8">

              <!-- Type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{"RegistrationPage.type" | translate}}</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-select 
                      [value]="element.type" 
                      (selectionChange)="onTypeChange($event.value, index)"
                      [disabled]="element.isCopied">
                      <mat-option value="P" [disabled]="hasPrimarySelected() && element.type !== 'P'">{{"RegistrationPage.primary" | translate}}</mat-option>
                      <mat-option value="S">{{"RegistrationPage.secondary" | translate}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Identification Type Column -->
              <ng-container matColumnDef="idType">
                <th mat-header-cell *matHeaderCellDef>
                  {{"RegistrationPage.identificationType" | translate}} <span *ngIf="mandatoryField.identificationType" class="red">*</span>
                </th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-select
                      [value]="element.idType"
                      [disabled]="isIdentificationTypeDisabled(element)"
                      (selectionChange)="primaryIdentificationOnChange($event, true, index)"
                      [placeholderLabel]="'RegistrationPage.identificationType' | translate"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="element.type === 'P' ? primaryIdSearch : secondaryIdSearch"
                          [placeholderLabel]="'RegistrationPage.search' | translate"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let option of element.type === 'P' ? primaryIdFilteredList : secondaryIdFilteredList" 
                      [value]="option.code"
                      [disabled]="isIdTypeSelected(option.code, index)">
                        {{ option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Identification Number Column -->
              <ng-container matColumnDef="idNumber">
                <th mat-header-cell *matHeaderCellDef>
                  {{"RegistrationPage.identificationNumber" | translate}} <span *ngIf="mandatoryField.identificationNo" class="red">*</span>
                </th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline" [ngClass]="{ 'field-error': !element.isIdNumberValid }">
                    <input
                      matInput
                      [value]="element.idNumber"
                      [attr.pattern]="element.primaryIdRegex"
                      [attr.maxlength]="element.maxIdentificationLength"
                      [attr.minlength]="element.minIdentificationLength"
                      [placeholder]="'RegistrationPage.primaryDocNo' | translate"
                      [disabled]="element.isCopied"
                      (input)="primaryNumberOnKeyUp($event.target.value, index,true);restrictToAllowedChars($event, element)"
                      (focusout)="onFocusOutEvent(element, index); checkDuplicatePatient('identificationNo',element)"
                    />
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Expiry Date Column -->
              <ng-container matColumnDef="expDate">
                <th mat-header-cell *matHeaderCellDef>{{"RegistrationPage.expiryDate" | translate}}
                  <span class="red" *ngIf="isExpiryHeaderRequired()">*</span>
                </th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <!-- <mat-form-field class="full-width" appearance="outline" [ngClass]="{ 'field-error': element.isExpiryDate && !element.expDate }">
                    <input
                      matInput
                      readonly
                      [value]="element.expDate"
                      [required]="element.isExpiryDate"
                      [min]="now"
                      [max]="maxExpiry"
                      [matDatepicker]="picker2"
                      [placeholder]="element.isExpiryDate? ('RegistrationPage.expiryDate' | translate) + ' *'  : ('RegistrationPage.expiryDate' | translate)"
                      attr.data-automation-attribute="dateExpiry"
                      name="acb"
                      (dateChange)="onExpiryDateChange($event.value, element)"
                      [disabled]="element.isCopied || !element.isExpiryRequired"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field> -->
                <mat-form-field class="full-width" appearance="outline" [ngClass]="{
                  'field-error':
                    element.isExpiryRequired && !element.expDate
                  }">
                  <input matInput readonly [value]="element.expDate" [required]="element.isExpiryRequired"
                            [min]="now" [max]="maxExpiry" [matDatepicker]="picker2" [placeholder]="
                   element.isExpiryRequired
                    ? ('RegistrationPage.expiryDate' | translate) + ' *'
                    : ('RegistrationPage.expiryDate' | translate)
                    " attr.data-automation-attribute="dateExpiry" name="acb" (dateChange)="
                      onExpiryDateChange($event.value, element)
                     " [disabled]="
                     element.isCopied ||
                     !element.isExpiryDisplayed
                     " />

                    <mat-datepicker-toggle matSuffix [for]="picker2">
                    </mat-datepicker-toggle>

                    <mat-datepicker #picker2>
                    </mat-datepicker>

                </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Issuing Country Column -->
              <ng-container matColumnDef="issuingCountry">
                <th mat-header-cell *matHeaderCellDef>{{"RegistrationPage.issuingCountry" | translate}}</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline" [ngClass]="{ 'field-error': element.isCountryRequired && !element.issuingCountry}">
                    <mat-select 
                      [required]="element.isCountryRequired"
                      [value]="element.issuingCountry"
                      (selectionChange)="setCountryValue($event.value, index,element)"
                      [disabled]="isDisabled || element.isCopied"
                      [placeholder]="element.isCountryRequired ? ('RegistrationPage.selectCountry' | translate) + ' *'  : ('RegistrationPage.selectCountry' | translate)"
                    >
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="countrySearch"
                        [placeholderLabel]="'RegistrationPage.search' | translate"
                      ></ngx-mat-select-search>
                    </mat-option>
                      <mat-option *ngFor="let country of countryPrimaryList" [value]="country.code">
                        {{ country.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Action Buttons Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>{{"RegistrationPage.action" | translate}}</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <ng-container *ngIf="!element.isCopied">
                    <button
                      mat-mini-fab
                      type="button"
                      [matTooltip]="'RegistrationPage.add' | translate"
                      class="min-btn btnCyan"
                      (click)="addIdentification(element)"
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                    &nbsp;&nbsp;
                    <button
                      *ngIf="element.type !== 'P'"
                      mat-mini-fab
                      type="button"
                      [matTooltip]="'RegistrationPage.delete' | translate"
                      class="min-btn btnRed"
                      (click)="deleteIdentification(index,element)"
                    >
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                    <button 
                      mat-mini-fab 
                      type="button"
                      [matTooltip]="'RegistrationPage.copy' | translate"
                      style="background-color: white" 
                      *ngIf="element.type == 'P' && selectedPatient && element.idType" 
                      (click)="copyPrimaryId(element, index)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </ng-container>
                </td>
              </ng-container>
            
              <!-- Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
            </table>
            
          </div>
          
          <!-- <mat-grid-list cols="12" rowHeight="50px">
            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline" >
                <mat-label>{{
                  "RegistrationPage.secondaryId" | translate
                }}</mat-label>
                <mat-select
                  attr.data-automation-attribute="sltSecondaryID"
                  formControlName="secondaryId"
                  (selectionChange)="secondartyIdentificationOnChange($event)"
                  [required]="mandatoryField.secIdentificationType"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="secondaryIdSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option>None</mat-option>
                  <mat-option
                    *ngFor="let option of secondaryIdFilteredList"
                    [value]="option.code"
                  >
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline" id="validate">
                <mat-label>{{
                  "RegistrationPage.secondaryDocNo" | translate
                }}</mat-label>
                <input
                  [pattern]="secondaryIdeRegex"
                  matInput
                  formControlName="secondaryNumber"
                  maxlength="25"
                  (keyup)="secondaryNumberOnKeyUp($event.target.value)"
                  [required]="mandatoryField.secIdentificationNo"
                  (focusout)="onFocusOutEventUpdate('')"
                  [placeholder]="'RegistrationPage.secondaryDocNo' | translate"
                  attr.data-automation-attribute="txtSecondaryIDDesc"
                  (blur)="checkValidEmployee()"
                />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label
                  >{{ "RegistrationPage.secondaryexpiryDate" | translate }}
                </mat-label>
                <input
                  matInput
                  formControlName="secondaryExpirydate"
                  [min]="now"
                  [required]="isSeondaryExpiryDate"
                  [max]="maxExpiry"
                  [matDatepicker]="picker3"
                  [placeholder]="
                    'RegistrationPage.secondaryexpiryDate' | translate
                  "
                  attr.data-automation-attribute="dateExpiry"
                  name="acb"
                  [disabled]="!isSeondaryExpiryDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker3"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <app-master-form-field
              [isRequired]="mandatoryField.faculty"
                [label]="'RegistrationPage.faculty' | translate"
                [masterName]="masterAPI.FACULTY_MASTER"
                [formControlName]="'faculty'"
                [defaultValue]="selectedPatient ? selectedPatient.faculty : ''"
                [parentForm]="formRegistration"
                [isSubmitted]="patientRegForm.submitted"
              >
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1">
              <mat-form-field
                appearance="outline"
                class="full-width"
                style="visibility: hidden"
              >
                <mat-label>Birth Time</mat-label>
                <input
                  matInput
                  id="Break Start Time"
                  type="time"
                  formControlName="birthTime"
                  matNativeControl
                  placeholder="Birth Time"
                  data-automation-attribute="text-from-time"
                />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list> -->
        </div>
        <div class="col-1">
          <div class="section-born">
            <mat-checkbox 
              formControlName="isDeceased" 
              [required]="mandatoryField.isDeceased" 
              (change)="deceasedRemove($event)">
              {{ "RegistrationPage.isDeceased" | translate }}
            </mat-checkbox> 
            <br><br>
            <mat-checkbox
              formControlName="isNewborn"
              (change)="onNewbornChange($event.checked)">
              {{ "RegistrationPage.newBorn" | translate }}
            </mat-checkbox>
            <br><br>
            <mat-checkbox
              formControlName="isInactive">
              {{ "RegistrationPage.inActive" | translate }}
            </mat-checkbox>
            <br><br>
            <mat-checkbox 
              formControlName="isRadioactiveImplant">
              {{ "RegistrationPage.radioactiveImplant" | translate }}
            </mat-checkbox> 
          </div>
        </div>
        
      </div>
      <mat-grid-list cols="12" rowHeight="85px">
        <!-- [ngStyle]="ispatientNameLtwo && !isFullName ? {'align-self': 'flex-start', 'vertical-align': 'top', 'position': 'relative', 'top': '-4px'} : null"> -->
        <!-- Prefix Field -->
        <mat-grid-tile [colspan]="2">
          <app-master-form-field 
            [isRequired]="mandatoryField.title"
            [label]="'RegistrationPage.prefix' | translate"
            [masterName]="masterAPI.PREFIX_MASTER"
            [formControlName]="'prefix'"
            [defaultValue]="titleValue"
            [parentForm]="formRegistration"
            (itemSelected)="getGender($event)"
            (autoLoadCompleted)="getGender($event)"
            [isSubmitted]="patientRegForm.submitted"
            [allowNA]="true"
            >
          </app-master-form-field>
        </mat-grid-tile>
      
        <!-- Full Name -->
        <mat-grid-tile [colspan]="5" *ngIf="isFullName">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "RegistrationPage.name" | translate }}</mat-label>
            <input matInput formControlName="fullName" maxlength="100"
              [placeholder]="'RegistrationPage.name' | translate"
              (input)="toUpperCase($event)"
              attr.data-automation-attribute="txtFirstName" />
          </mat-form-field>
        </mat-grid-tile>
      
        <!-- Individual Name Fields -->
        <mat-grid-tile [colspan]="5" *ngIf="!ispatientNameLtwo && !isFullName">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "master.firstName" | translate }}</mat-label>
            <input matInput formControlName="firstName" maxlength="100"
              [placeholder]="'master.firstName' | translate"
              (input)="toUpperCase($event)"
              attr.data-automation-attribute="txtFirstName" (blur)="checkDuplicatePatient('dateOfBirth')"/>
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "master.middleName" | translate }}</mat-label>
            <input matInput formControlName="middleName" maxlength="100"
              [placeholder]="'master.middleName' | translate"
              (input)="toUpperCase($event)"
              attr.data-automation-attribute="txtMiddleName" />
          </mat-form-field>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "master.lastName" | translate }}</mat-label>
            <input matInput formControlName="lastName" maxlength="100"
              [placeholder]="'master.lastName' | translate"
              (input)="toUpperCase($event)"
              attr.data-automation-attribute="txtLastName" (blur)="checkDuplicatePatient('dateOfBirth')"/>
          </mat-form-field>
        </mat-grid-tile>
      
        <!-- Thai Name Fields -->
        <mat-grid-tile [colspan]="5" *ngIf="ispatientNameLtwo && !isFullName">
          <div class="name-l2-grid">
            <!-- <div> -->
              <mat-form-field class="name-field" appearance="outline">
                <mat-label>{{"AppointmentPage.firstNameTh" | translate}}</mat-label>
                <input matInput formControlName="firstNameTh" maxlength="100" (input)="toUpperCase($event)"
                [placeholder]="'master.firstName' | translate" (blur)="checkDuplicatePatient('dateOfBirth')"/>
              </mat-form-field>
              <mat-form-field class="name-field" appearance="outline">
                <mat-label>{{"AppointmentPage.middleNameTh" | translate}}</mat-label>
                <input matInput formControlName="middleNameTh" maxlength="100" (input)="toUpperCase($event)"
                [placeholder]="'master.middleName' | translate" />
              </mat-form-field>
              <mat-form-field class="name-field" appearance="outline">
                <mat-label>{{"AppointmentPage.lastNameTh" | translate}}</mat-label>
                <input matInput formControlName="lastNameTh" maxlength="100" (input)="toUpperCase($event)"
                [placeholder]="'master.lastName' | translate"  (blur)="checkDuplicatePatient('dateOfBirth')"/>
              </mat-form-field>
            <!-- </div> -->
            
            <!-- <div class="three-name-row"> -->
              <mat-form-field class="name-field" appearance="outline">
                <mat-label>{{"AppointmentPage.firstNameEn" | translate}}</mat-label>
                <input matInput formControlName="firstName" maxlength="100"
                  [placeholder]="'AppointmentPage.firstName' | translate" 
                  (input)="toUpperCase($event)" (blur)="checkDuplicatePatient('dateOfBirth')" />
              </mat-form-field>
              <mat-form-field class="name-field" appearance="outline">
                <mat-label>{{"AppointmentPage.middleNameEn" | translate}}</mat-label>
                <input matInput formControlName="middleName" maxlength="100"
                  [placeholder]="'AppointmentPage.middleName' | translate" 
                  (input)="toUpperCase($event)" />
              </mat-form-field>
              <mat-form-field class="name-field" appearance="outline">
                <mat-label>{{"AppointmentPage.lastNameEn" | translate}}</mat-label>
                <input matInput formControlName="lastName" maxlength="100"
                  [placeholder]="'AppointmentPage.lastName' | translate" 
                  (input)="toUpperCase($event)" (blur)="checkDuplicatePatient('dateOfBirth')" />
              </mat-form-field>
            <!-- </div> -->
    
          </div>
        </mat-grid-tile>
      
        <!-- Gender -->
        <mat-grid-tile [colspan]="1">
          <app-master-form-field 
            [isRequired]="true"
            [label]="'RegistrationPage.gender' | translate"
            [masterName]="masterAPI.GENDER_MASTER"
            [formControlName]="'gender'"
            [defaultValue]="genderValue"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
            (itemSelected)="checkDuplicatePatient('dateOfBirth')">
          </app-master-form-field>
        </mat-grid-tile>
      
        <!-- Date of Birth -->
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "master.dob" | translate }}</mat-label>
            <input matInput formControlName="dateOfBirth"
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="picker1"
              [required]="mandatoryField.dateOfBirth"
              (input)="formatDOBInput($event)"
              [placeholder]="'RegistrationPage.dobForm' | translate"
              (dateChange)="checkDuplicatePatient('dateOfBirth')"
              (blur)="dobValidation($event);"
              attr.data-automation-attribute="dateDOB" />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>
      
        <!-- Patient Age -->
        <mat-grid-tile [colspan]="2">
        <div class="patient-age">
          <div class="year">
            <input matInput [value]="patientAge?.years" (input)="calculateDob($event.target.value, patientAge?.months, patientAge?.days)" 
              oninput="if (this.value > 200) this.value = 200;"/>
            <span class="unit">{{ "RegistrationPage.y" | translate }}</span>
          </div>
          <div class="months">
            <input matInput [value]="patientAge?.months" (input)="calculateDob(patientAge?.years, $event.target.value, patientAge?.days)" />
            <span class="unit">{{ "RegistrationPage.m" | translate }}</span>
          </div>
          <div class="days">
            <input matInput [value]="patientAge?.days"  (input)="calculateDob(patientAge?.years, patientAge?.months, $event.target.value)" />
            <span class="unit">{{ "RegistrationPage.d" | translate }}</span>
          </div>
        </div>
      
      </mat-grid-tile>
      
      </mat-grid-list>
      
    </div>
    <div class="form-container" attr.data-automation-attribute="divIDDetails">
      <mat-grid-list cols="12" rowHeight="50px">
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
          [isRequired]="mandatoryField.martial"
            [label]="'RegistrationPage.maritalStatus' | translate"
            [masterName]="masterAPI.MARITAL_MASTER"
            [formControlName]="'martial'"
            [defaultValue]="
              selectedPatient ? selectedPatient.martialStatus : ''
            "
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        
        <!-- [defaultValue]="selectedPatient ? selectedPatient.religion : ''" -->
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.religion"
            [label]="'RegistrationPage.religion' | translate"
            [masterName]="masterAPI.RELIGION_MASTER"
            [formControlName]="'religion'"
            [defaultValue]="religionValue"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{"RegistrationPage.race" | translate }} </mat-label>
            <mat-select formControlName="race"
            [required]="mandatoryField.race">
            <mat-option>
            <ngx-mat-select-search
            [formControl]="raceMasterSearch"
            [placeholderLabel]="'RegistrationPage.search' | translate"
          ></ngx-mat-select-search>
          </mat-option>
              <mat-option>{{"RegistrationPage.none" | translate }}</mat-option>
              <mat-option
              *ngFor="let option of raceFilterList"
                [value]="option.code"
              >
                {{ option.desc }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" *ngIf="isNationDependant==false">
          <app-master-form-field 
          [isRequired]="mandatoryField.nation"
            [label]="'RegistrationPage.nationality' | translate"
            [masterName]="masterAPI.NATIONALITY_MASTER"
            [formControlName]="'nation'"
            [defaultValue]="selectedPatient ? selectedPatient.nationality : defaultNationality"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
        </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2"  *ngIf="isNationDependant==true" >
          <app-master-form-field 
          [isRequired]="mandatoryField.nation"
            [label]="'RegistrationPage.nationality' | translate"
            [masterName]="masterAPI.NATIONALITY_MASTER"
            [formControlName]="'nation'"
            [defaultValue]="selectedPatient ? selectedPatient.nationality : defaultNationality"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
            (itemSelected)="selectNationality($event)"
          >
        </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1">
          <mat-checkbox formControlName="isVip" [required]="mandatoryField.isVip" (change)="updateVIPStatus($event)">
            {{ "RegistrationPage.vipPatient" | translate }}
          </mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "aliasName" | translate }}</mat-label>
            <input
              matInput
              maxlength="50"
              formControlName="aliasName"
              [placeholder]="'aliasName' | translate"
              (input)="toUpperCase($event)"
              attr.data-automation-attribute="txtAliasName"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1">
        <mat-checkbox formControlName="isdobNotKnown">
           {{ "RegistrationPage.dobNotKnown" | translate }}</mat-checkbox>
        </mat-grid-tile>
      </mat-grid-list>

      <mat-grid-list cols="12" rowHeight="50px">
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.patientCategory"
            [label]="'RegistrationPage.patientCategory' | translate"
            [masterName]="masterAPI.PATIENT_CATEGORY_MASTER"
            [formControlName]="'patientCategory'"
            [defaultValue]="
              selectedPatient ? selectedPatient.patientCategory : ''
            "
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
            (selectionChange)="getTariffList()"
            (itemSelected)="updateExpiryValidation()"
          >
          </app-master-form-field>
        </mat-grid-tile>
        
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.bloodGroup"
            [label]="'RegistrationPage.bloodGroup' | translate"
            [masterName]="masterAPI.BLOOD_GROUP_MASTER"
            [formControlName]="'bloodGroup'"
            [defaultValue]="selectedPatient ? selectedPatient.bloodGroup : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{
              "RegistrationPage.motherName" | translate
            }}</mat-label>
            <input
            [required]="mandatoryField.motherName"
              matInput
              maxlength="25"
              formControlName="motherName"
              [placeholder]="'RegistrationPage.motherName' | translate"
              attr.data-automation-attribute="
                registration - form - motherName
              "
              (input)="inputValidation.replaceSpaces($event);toUpperCase($event);"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{
              "RegistrationPage.birthplace" | translate
            }}</mat-label>
            <input
              matInput
              [required]="mandatoryField.birthPlace"
              formControlName="birthplace"
              [placeholder]="'RegistrationPage.birthplace' | translate"
              attr.data-automation-attribute="birthplace"
              pattern="([a-zA-Z0-9,'<>?-._[]{}|/!@#$%^&*\s]+)"
              (input)="toUpperCase($event)"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.source"
            [label]="'EncounterPage.source' | translate"
            [masterName]="masterAPI.PATIENT_SOURCE_MASTER"
            [formControlName]="'sourceType'"
            [defaultValue]="selectedPatient ? selectedPatient.source : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label
              >{{ "RegistrationPage.TINNo" | translate }}
            </mat-label>
            <input
              matInput
              formControlName="tinNo"
              maxlength="20"
              [placeholder]="'RegistrationPage.TINNo' | translate"
              attr.data-automation-attribute="txtPrimaryIDDesc"
              pattern="[a-zA-Z0-9]+"
              (input)="toUpperCase($event)"
            />
          </mat-form-field>
        </mat-grid-tile>
      

      </mat-grid-list>
      <mat-grid-list cols="12" rowHeight="50px">
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.ethnic"
            [label]="'RegistrationPage.ethnic' | translate"
            [masterName]="masterAPI.ETHNIC_MASTER"
            [formControlName]="'ethnic'"
            [defaultValue]="selectedPatient ? selectedPatient.ethnic : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" *ngIf="showField.EmploymentStatus">
          <app-master-form-field
            [isRequired]="mandatoryField.EmploymentStatus"
            [label]="'RegistrationPage.employmentStatus' | translate"
            [masterName]="masterAPI.EMPLOYMENT_STATUS_MASTER"
            [formControlName]="'employmentStatus'"
            [defaultValue]="
              selectedPatient ? selectedPatient.employmentStatus : ''
            "
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" *ngIf="!showField.EmploymentStatus">
          <app-master-form-field
            [isRequired]="mandatoryField.occupation"
            [label]="'RegistrationPage.occupation' | translate"
            [masterName]="masterAPI.OCCUPATION_MASTER"
            [formControlName]="'occupation'"
            [defaultValue]="selectedPatient ? selectedPatient.occupation : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.prefLang"
            [label]="'RegistrationPage.preferedLanguage' | translate"
            [masterName]="masterAPI.LANGUAGE_MASTER"
            [formControlName]="'preferredLanguage'"
            [defaultValue]="
              selectedPatient ? selectedPatient.preferedLanguage : ''
            "
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile> 

        <mat-grid-tile [colspan]="6">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "RegistrationPage.patientNotes" | translate }}</mat-label>
            <input
              [required]="mandatoryField.patientNotes"
              formControlName="patientNotes"
              matInput
              placeholder="Patient Notes"
              pattern="([a-zA-Z0-9,'<>?-._[]{}|/!@#$%^&*\s]+)"
              maxlength="100"
              attr.data-automation-attribute="txtPermanentAddress"
            />
          </mat-form-field>
        </mat-grid-tile>

<!--         
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.education"
            [label]="'RegistrationPage.education' | translate"
            [masterName]="masterAPI.EDUCATION_MASTER"
            [formControlName]="'education'"
            [defaultValue]="selectedPatient ? selectedPatient.education : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile> -->

        <!-- <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.occupation"
            [label]="'RegistrationPage.occupation' | translate"
            [masterName]="masterAPI.OCCUPATION_MASTER"
            [formControlName]="'occupation'"
            [defaultValue]="selectedPatient ? selectedPatient.occupation : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile> -->
      </mat-grid-list>
      <div class="full-content">
        <mat-grid-list cols="12" rowHeight="50px">
          <mat-grid-tile [colspan]="6">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.permanentAddress" | translate
              }}</mat-label>
              <input
                matInput
                maxlength="100"
                [required]="mandatoryField.addressPrimary"
                formControlName="addressPrimary"
                [placeholder]="
                  'RegistrationPage.permanentAddress' | translate
                "
               (input)="toUpperCaseAddress($event)"
                attr.data-automation-attribute="txtAddress"
                pattern="([A-Z0-9-.\u0E00-\u0E7F,<>?-._[\]{}|/!@#$%^&*\s]+)"

              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.CountryCode"
              [label]="'EncounterPage.countryCode' | translate"
              [masterName]="masterAPI.COUNTRY_CODE_MASTER"
              [formControlName]="'countryCodemobile'"
              [defaultValue]="countryCodeValue"
              [parentForm]="formRegistration"
              [isSubmitted]="patientRegForm.submitted"
              (itemSelected)="setPatternToMobileNumber($event)"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.handphoneNo" | translate
              }}</mat-label>
              <input
                matInput                      
                [minlength]="mobileNoMin"
                [maxlength]="mobileNoMax"
                type="text"
                oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                [required]="mandatoryField.mobileNumber"
                formControlName="mobileNumber"
                attr.data-automation-attribute="
                  registration - form - localcontact
                "
                (blur)="checkDuplicatePatient('mobileNumber')"
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.mobileNoRelation"
              [label]="'EncounterPage.relation' | translate"
              [masterName]="masterAPI.RELATION_MASTER"
              [formControlName]="'contactRelation'"
              [defaultValue]="
                selectedPatient ? selectedPatient.relation : ''
              "
              [parentForm]="formRegistration"
              [isSubmitted]="patientRegForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="12" rowHeight="50px">
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.countryPrimary"
              [label]="'RegistrationPage.country' | translate"
              [masterName]="masterAPI.COUNTRY_MASTER"
              [formControlName]="'countryPrimary'"
              [parentForm]="formRegistration"
              [defaultValue]="countryValue?countryValue:defaultCountry"
              (itemSelected)="getStatePrimaryList($event, false);getCountryCode($event, true)"
              [isSubmitted]="patientRegForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.statePrimary"
              [label]="'RegistrationPage.state' | translate"
              [masterName]="masterAPI.STATE_MASTER_QUERY"
              [formControlName]="'statePrimary'"
              [parentForm]="formRegistration"
              [params]="CountryCode"
              [defaultValue]="stateValue"
              (itemSelected)="getCityPrimaryList($event)"
              [isSubmitted]="patientRegForm.submitted"
              [allowNA]="true"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.cityPrimary"
              [label]="'RegistrationPage.city' | translate"
              [masterName]="masterAPI.CITY_MASTER_QUERY"
              [formControlName]="'cityPrimary'"
              [params]="StateCode"
              [defaultValue]="cityValue"
              [parentForm]="formRegistration"
              (itemSelected)="getSubDistrictPrimaryList($event)"
              [isSubmitted]="patientRegForm.submitted"              
              [allowNA]="true"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
            [isRequired]="mandatoryField.areaPrimary"
              [label]="'RegistrationPage.district' | translate"
              [masterName]="masterAPI.DIST_MASTER_QUERY"
              [formControlName]="'subDistrictPrimary'"
              [params]="CityCode"
              [defaultValue]="districtValue"
              [parentForm]="formRegistration"
              [isSubmitted]="patientRegForm.submitted"
              (itemSelected)="primaryDistrictSelected($event)"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.zipcode" | translate
              }}</mat-label>
              <input
                matInput
                type="text"
                formControlName="pincodePrimary"
                numberOnly
                class="example-right-align"
                [placeholder]="'RegistrationPage.zipcode' | translate"
                attr.data-automation-attribute="txtPincode"
                [required]="mandatoryField.pincodePrimary"
                pattern="[a-zA-Z0-9]+"
                maxlength="10"
                (focusout)="getAddressByPostCode($event.target.value)"
              />
            </mat-form-field>
            
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1">
            <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
              <mat-checkbox 
                style="margin-left: auto; margin-right: auto;"
                [(ngModel)]="isGetAddress"
                [ngModelOptions]="{ standalone: true }"
                (change)="searchByPostCode($event)">
                {{ "RegistrationPage.search" | translate }}
              </mat-checkbox>
            </div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.emailID" | translate
              }}</mat-label>
              <input
                [required]="mandatoryField.emailId"
                matInput
                formControlName="emailId"
                [placeholder]="'RegistrationPage.emailID' | translate"
                attr.data-automation-attribute="txtEmail"
                pattern="^([a-zA-Z0-9_.+\\-*]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+|[a-zA-Z0-9*]+)$"
                (blur)="checkDuplicatePatient('emailId')"
              />
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="12" rowHeight="50px">
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.localContact" | translate
              }}</mat-label>
              <input
                matInput
                [required]="mandatoryField.isHandphone"
                formControlName="homeContact"
                minlength="10"
                maxlength="14"
                (input)="mobileFormat($event.target.value, 'home')"
                (keydown.delete)="mobileDelete($event)"
                [placeholder]="
                  'RegistrationPage.localContact' | translate
                "
                attr.data-automation-attribute="
                  registration - form - handphone
                "
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.personalFaxno" | translate
              }}</mat-label>
              <input
                matInput
                [required]="mandatoryField.personalFax"
                [pattern]="faxRegex"
                formControlName="personalFax"
                (keyup)="mobileFormat($event.target.value, 'personalfax')"
                [placeholder]="
                  'RegistrationPage.personalFaxno' | translate
                "
                attr.data-automation-attribute="
                  registration - form - personalFax
                "
                pattern="[a-zA-Z0-9]+"
                maxlength="15"
              />
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.workFaxno" | translate
              }}</mat-label>
              <input
                matInput
                [required]="mandatoryField.workFax"
                [pattern]="faxRegex"
                formControlName="workFax"
                (keyup)="mobileFormat($event.target.value, 'workfax')"
                [placeholder]="'RegistrationPage.workFaxno' | translate"
                attr.data-automation-attribute="
                  registration - form - workFax
                "
                pattern="[a-zA-Z0-9]+"
                maxlength="15"
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.officeContact" | translate
              }}</mat-label>
              <input
                (keyup)="mobileFormat($event.target.value, 'work')"
                formControlName="workContact"
                [required]="mandatoryField.workContact"
                matInput
                [placeholder]="
                  'RegistrationPage.officeContact' | translate
                "
                attr.data-automation-attribute="registration - form - email"
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.vipRemarks" | translate
              }}</mat-label>
              <input
                formControlName="vipRemarks"
                matInput
                [placeholder]="
                  'RegistrationPage.vipRemarks' | translate
                "
              />
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="12" rowHeight="50px" *ngIf="isNeedTranslator">
          
          <mat-grid-tile [colspan]="2">
            <div class="translator-left">
            <mat-checkbox formControlName="needTranslator">
              {{ "RegistrationPage.needTranslator" | translate }}
            </mat-checkbox>
            </div>
          </mat-grid-tile>
        
          <mat-grid-tile [colspan]="3" *ngIf="formRegistration.get('needTranslator')?.value">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>
                {{ "RegistrationPage.translatorNote" | translate }}
              </mat-label>
              <input matInput formControlName="translatorLanguage" maxlength="250"
                [placeholder]="'RegistrationPage.translatorNote' | translate" />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="7"></mat-grid-tile>
          </mat-grid-list>
        </div>
    </div>
    </mat-tab>
      <!-- Registration: Address and Contact Tab -->
      <mat-tab class="tabSubPersonalDetails">
        <ng-template mat-tab-label>
          {{ "RegistrationPage.localAddress" | translate }}
        </ng-template>
        <!-- Registration: Address Details -->
        <mat-grid-list cols="12" rowHeight="70px">
          <mat-grid-tile [colspan]="10">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.localAddress" | translate
              }}</mat-label>
              <input
                [required]="mandatoryField.addressSecondary"
                formControlName="addressSecondary"
                maxlength="100"
                matInput
                [placeholder]="
                  'RegistrationPage.localAddress' | translate
                "
                (input)="toUpperCase($event)"
                attr.data-automation-attribute="txtPermanentAddress"
                pattern="([a-zA-Z0-9,'<>?-._[]{}|/!@#$%^&*\s]+)"
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-checkbox
              (change)="bothAddressSame($event)"
              [placeholder]="
                'RegistrationPage.sameAsPermanentAddress' | translate
              "
              attr.data-automation-attribute="chkSameAsLocalAddress"
              [(ngModel)]="isBothAddressSame"
              [ngModelOptions]="{ standalone: true }"
              >{{
                "RegistrationPage.sameAsPermanentAddress" | translate
              }}</mat-checkbox
            >
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="12" rowHeight="50px">
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.countrySecondary"
              [label]="'RegistrationPage.country' | translate"
              [masterName]="masterAPI.COUNTRY_MASTER"
              [formControlName]="'countrySecondary'"
              [parentForm]="formRegistration"
              [defaultValue]="countrySecondaryValue"
              (itemSelected)="getStateSecondaryList($event, false)"
              [isSubmitted]="patientRegForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.stateSecondary"
              [label]="'RegistrationPage.state' | translate"
              [masterName]="masterAPI.STATE_MASTER_QUERY"
              [formControlName]="'stateSecondary'"
              [parentForm]="formRegistration"
              [defaultValue]="stateSecondaryValue"
              [params]="secondaryCountryCode"
              (itemSelected)="getCitySecondaryList($event)"
              [isSubmitted]="patientRegForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [isRequired]="mandatoryField.citySecondary"
              [label]="'RegistrationPage.city' | translate"
              [masterName]="masterAPI.CITY_MASTER_QUERY"
              [formControlName]="'citySecondary'"
              [parentForm]="formRegistration"
              [defaultValue]="citySecondaryValue"
              [params]="secondaryStateCode"
              (itemSelected)="getSubDistrictSecondaryList($event)"
              [isSubmitted]="patientRegForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
            [isRequired]="mandatoryField.areaSecondary"
              [label]="'RegistrationPage.subArea' | translate"
              [masterName]="masterAPI.DIST_MASTER_QUERY"
              [formControlName]="'subDistrictSecondary'"
              [parentForm]="formRegistration"
              [defaultValue]="districtSeoncdaryValue"
              [params]="secondaryDistrictCode"
              [isSubmitted]="patientRegForm.submitted"
              (itemSelected)="secondaryDistrictSelected($event)"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "RegistrationPage.zipcode" | translate
              }}</mat-label>
              <input
                [required]="mandatoryField.pincodeSecondary"
                matInput
                type="text"
                maxlength="10"
                numberOnly
                formControlName="pincodeSecondary"
                class="example-right-align"
                [placeholder]="'RegistrationPage.zipcodeP' | translate"
                attr.data-automation-attribute="txtPermanentPincode"
                pattern="[a-zA-Z0-9]+"
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1">
            <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
              <mat-checkbox 
                style="margin-right: auto;"
                [(ngModel)]="isGetAddress"
                [ngModelOptions]="{ standalone: true }"
                (change)="searchByPostCode($event)">
                {{ "RegistrationPage.search" | translate }}
              </mat-checkbox>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
        <!-- <div class="flex">
          <div class="div-lg">
            <div
              class="form-container"
              style="margin-right: 10px"
              attr.data-automation-attribute="divPersonalDetails"
            >
              <b class="section-head">{{
                "RegistrationPage.address" | translate
              }} <mat-checkbox 
              style="margin-left: 75%;color: black;"
              [(ngModel)]="isGetAddress"
              [ngModelOptions]="{ standalone: true }"
              (change)="searchByPostCode($event)">{{
                "RegistrationPage.SearchByPostcode" | translate
              }}</mat-checkbox>
            </b>
             
           
            
              <div class="full-content">
               
              </div>
            </div>
          </div>

        
        </div> -->
      </mat-tab>
      <!-- Registration: Employment Details Tab -->
      <mat-tab class="tabSubPersonalDetails">
        <ng-template mat-tab-label>
          {{ "RegistrationPage.employmentDetails" | translate }}
        </ng-template>
        <div class="flex">
          <div class="div-lgp">
            <div
              class="form-container"
              style="margin-right: 10px"
              attr.data-automation-attribute="divPersonalDetails"
            >
              <div class="full-content">
                <mat-grid-list cols="12" rowHeight="50px">
                  <!-- Bind Dropdown -->
                  <div>
                    <mat-grid-tile [colspan]="2">
                      <mat-form-field class="full-width" appearance="outline">
                        <mat-label>
                          {{ "RegistrationPage.employer" | translate }}
                        </mat-label>
                        <mat-select
                          id="Employer"
                          attr.data-automation-attribute="employerName"
                          formControlName="employerName"
                        >
                          <mat-option>{{
                            "RegistrationPage.none" | translate
                          }}</mat-option>
                          <mat-option
                            *ngFor="let option of employerList"
                            [value]="option.code"
                          >
                            {{ option.desc }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-grid-tile>
                  </div>

                  <div *ngIf="employer">
                    <mat-grid-tile [colspan]="2">
                      <mat-form-field class="full-width" appearance="outline">
                        <mat-label>
                          {{ "RegistrationPage.others" | translate }}
                        </mat-label>
                        <input
                          matInput
                          type="text"
                          maxlength="100"
                          formControlName="employerNameOthers"
                          attr.data-automation-attribute="employerNameOthers"
                        />
                      </mat-form-field>
                    </mat-grid-tile>
                  </div>
                  <mat-grid-tile [colspan]="2">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>
                        {{ "RegistrationPage.employmentNo" | translate }}
                      </mat-label>
                      <input
                        matInput
                        type="text"
                        maxlength="25"
                        formControlName="employmentNo"
                        attr.data-automation-attribute="employmentNo"
                        (input)="inputValidation.replaceSpaces($event);toUpperCase($event);"
                      />
                    </mat-form-field>
                  </mat-grid-tile>

                  <mat-grid-tile [colspan]="2">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>
                        {{ "RegistrationPage.workingFrom" | translate }}
                      </mat-label>
                      <input
                        matInput
                        formControlName="workingFrom"
                        [max]="now"
                        [matDatepicker]="picker4"
                        [placeholder]="
                          'RegistrationPage.workingFrom' | translate
                        "
                        attr.data-automation-attribute="workingFromDate"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker4"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker4></mat-datepicker>
                    </mat-form-field>
                  </mat-grid-tile>

                  <mat-grid-tile [colspan]="2">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>
                        {{ "RegistrationPage.contactNo" | translate }}
                      </mat-label>
                      <input
                        matInput
                        type="text"
                        maxlength="15"
                        formControlName="employmentContactNo"
                        attr.data-automation-attribute="employmentContactNo"
                        [pattern]="'[0-9+-]*'" 
                      />
                    </mat-form-field>
                  </mat-grid-tile>
                </mat-grid-list>

                <mat-grid-list cols="12" rowHeight="50px">
                  <mat-grid-tile [colspan]="4">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>{{
                        "RegistrationPage.employmentAddress" | translate
                      }}</mat-label>
                      <input
                        matInput
                        maxlength="100"
                        formControlName="employmentAddress"
                        [placeholder]="
                          'RegistrationPage.permanentAddress' | translate
                        "
                        attr.data-automation-attribute="employmentAddress"
                      />
                    </mat-form-field>
                  </mat-grid-tile>

                  <mat-grid-tile [colspan]="2">
                    <app-master-form-field
                      [label]="'RegistrationPage.country' | translate"
                      [masterName]="masterAPI.COUNTRY_MASTER"
                      [formControlName]="'employmentCountry'"
                      [defaultValue]="countryEmploymentValue"
                      [parentForm]="formRegistration"
                      (itemSelected)="getStateEmploymentList($event, false)"
                      [isSubmitted]="patientRegForm.submitted"
                    >
                    </app-master-form-field>
                  </mat-grid-tile>

                  <mat-grid-tile [colspan]="2">
                    <app-master-form-field
                      [label]="'RegistrationPage.state' | translate"
                      [masterName]="masterAPI.STATE_MASTER_QUERY"
                      [formControlName]="'employmentState'"
                      [defaultValue]="stateEmploymentValue"
                      [parentForm]="formRegistration"
                      [params]="employmentCountryCode"
                      (itemSelected)="getCityEmploymentList($event)"
                      [isSubmitted]="patientRegForm.submitted"
                    >
                    </app-master-form-field>
                  </mat-grid-tile>

                  <mat-grid-tile [colspan]="2">
                    <app-master-form-field
                      [label]="'RegistrationPage.city' | translate"
                      [masterName]="masterAPI.CITY_MASTER_QUERY"
                      [formControlName]="'employmentCity'"
                      [defaultValue]="cityEmploymentValue"
                      [parentForm]="formRegistration"
                      [params]="employmentStateCode"
                      [isSubmitted]="patientRegForm.submitted"
                    >
                    </app-master-form-field>
                  </mat-grid-tile>

                  <mat-grid-tile [colspan]="2">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>{{
                        "RegistrationPage.zipcode" | translate
                      }}</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="employmentPostCode"
                        numberOnly
                        maxlength="15"
                        class="example-right-align"
                        [placeholder]="'RegistrationPage.zipcode' | translate"
                        attr.data-automation-attribute="employmentPostCode"
                        pattern="[a-zA-Z0-9]+"
                      />
                    </mat-form-field>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Registration: Health Tourist Details Tab -->
      <mat-tab class="tabSubPersonalDetails" *ngIf="!IsHealthTourist">
        <ng-template mat-tab-label>
          {{"RegistrationPage.healthTouristDetails" | translate}}
        </ng-template>
        <div class="form-container"
              style="margin-right: 10px">
        <form [formGroup]="formHealthTourist" #regHealthForm="ngForm" 
        attr.data-automation-attribute="formUserPersonalDetails">
        <mat-grid-list cols="14" rowHeight="50px">
          
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label> {{"RegistrationPage.HealthTouristCode" | translate}}</mat-label>
              <input matInput  formControlName="code" (input)="toUpperCase($event)"/>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="2">
            <app-master-form-field
            [isRequired]="true"
              [label]="'RegistrationPage.AgentIdentificationType' | translate"
              [masterName]="masterAPI.IDENTIFICATION_TYPE_MASTER"
              [formControlName]="'identificationType'"
              [parentForm]="formHealthTourist"
              [isSubmitted]="regHealthForm.submitted"
              >
            </app-master-form-field>
          </mat-grid-tile>
          
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label> {{"RegistrationPage.AgentIdentificationNo" | translate}}</mat-label>
                <input matInput type="number" formControlName="identificationNumber" />
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label> {{"RegistrationPage.AgentName" | translate}}</mat-label>
                <input matInput formControlName="agentName"
                oninput="this.value = this.value.toUpperCase()" />
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="2">
            
              <mat-form-field class="full-width" appearance="outline">
                <mat-label> {{"RegistrationPage.startend" | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="picker5" required>
                  <input matStartDate placeholder="Start date" formControlName="startDate">
                  <input matEndDate placeholder="End date" formControlName="endDate">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
              </mat-form-field>
              <mat-date-range-picker #picker5></mat-date-range-picker>
              
            </mat-grid-tile>

            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label> {{"RegistrationPage.contactNo" | translate}} </mat-label>
                <input matInput type="number" formControlName="contactNo" />
              </mat-form-field>
            </mat-grid-tile>

        </mat-grid-list>
        <mat-grid-list cols="14" rowHeight="50px">
              <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label> {{"RegistrationPage.emailId" | translate}}</mat-label>
                <input matInput formControlName="emailId" />
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label> {{"RegistrationPage.address" | translate}} </mat-label>
                <input matInput formControlName="address" (input)="toUpperCase($event)"/>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="2">
              <app-master-form-field
              [label]="'RegistrationPage.country' | translate"
              [masterName]="masterAPI.COUNTRY_MASTER"
              [formControlName]="'country'"
              [parentForm]="formHealthTourist"
              (itemSelected)="getStatePrimaryList($event, false)"
              [isSubmitted]="regHealthForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [label]="'RegistrationPage.state' | translate"
              [masterName]="masterAPI.STATE_MASTER_QUERY"
              [formControlName]="'state'"
              [parentForm]="formHealthTourist"
              [params]="CountryCode"
              (itemSelected)="getCityPrimaryList($event)"
              [isSubmitted]="regHealthForm.submitted"
            >
            </app-master-form-field>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <app-master-form-field
              [label]="'RegistrationPage.city' | translate"
              [masterName]="masterAPI.CITY_MASTER_QUERY"
              [formControlName]="'city'"
              [params]="StateCode"
              [parentForm]="formHealthTourist"
              [isSubmitted]="regHealthForm.submitted"
            >
            </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                        "RegistrationPage.postCode" | translate
                      }}</mat-label>
                <input matInput  formControlName="postcode" />
              </mat-form-field>
            </mat-grid-tile>
          

            <mat-grid-tile [colspan]="1">
              <button
              class="btnCyan"
              mat-mini-fab
              (click)="addHealthTourist(formHealthTourist.value)"
              [matTooltip]="'RegistrationPage.addHealthTouristList' | translate">
              <mat-icon>add</mat-icon
              >
            </button>
            </mat-grid-tile>
          </mat-grid-list>
        </form>
          <div class="Health-table">
          <table
          id="healthTourist"
          mat-table
          [dataSource]="healthTouristSource"
          class="mat-elevation-z8"
         >
          <ng-container matColumnDef="touristCode">
            <th mat-header-cell *matHeaderCellDef > {{"RegistrationPage.touristCode" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.code}}
            </td>
          </ng-container>
          <ng-container matColumnDef="identificationType">
            <th mat-header-cell *matHeaderCellDef > {{"RegistrationPage.IdentificationType" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.identificationType.desc?element.identificationType.desc:""}}
            </td>
          </ng-container>
          <ng-container matColumnDef="identificationNo">
            <th mat-header-cell *matHeaderCellDef > {{"RegistrationPage.IdentificationNo" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.identificationNumber}}
            </td>
          </ng-container>
          <ng-container matColumnDef="agentName">
            <th mat-header-cell *matHeaderCellDef >{{"RegistrationPage.AgentName" | translate}} </th>
            <td mat-cell *matCellDef="let element;">{{element.agentName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="startEndDate">
            <th mat-header-cell *matHeaderCellDef > {{"RegistrationPage.startEnd" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.startDate|date: "dd/MM/yyy"}} - {{element.endDate|date: "dd/MM/yyy"}}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactNo">
            <th mat-header-cell *matHeaderCellDef > {{"SearchHeader.phone" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.contactNo}}
            </td>
          </ng-container>
          <ng-container matColumnDef="emailId">
            <th mat-header-cell *matHeaderCellDef >{{"RegistrationPage.emailID" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.emailId}}
            </td>
          </ng-container>
          <ng-container matColumnDef="addedOn">
            <th mat-header-cell *matHeaderCellDef > {{"mrd.addedOn" | translate}}</th>
            <td mat-cell *matCellDef="let element;">{{element.currentDate  |date :"dd/MM/yyyy hh:mm aa"}}
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef > {{"update.action" | translate}}</th>
            <td mat-cell *matCellDef="let element;">
              <mat-icon (click)="deleteHealthTourist(element)">delete</mat-icon>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="healthTouristColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: healthTouristColumns"></tr>
        </table>
        </div>
        </div>
      </mat-tab>

      <!-- Registration: Documents Tab -->
      <mat-tab class="tabSubPersonalDetails" *ngIf="showRegistrationDocumentUpload">
        <ng-template mat-tab-label>
          {{ "EncounterPage.documents" | translate }}
        </ng-template>
        <div *ngIf="patientForm" class="flex">
          <div class="div-lgp">
            <div
              class="form-container"
              style="margin-right: 10px"
              attr.data-automation-attribute="divPersonalDetails"
            >
              <div class="file-table">
                <table
                  mat-table
                  [dataSource]="fileSourceReg"
                  class="mat-elevation-z8"
                >
                  <ng-container matColumnDef="docType" >
                    <th mat-header-cell *matHeaderCellDef>
                      {{ "DocumentUpload.documentType" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="custom-cell">
                      <mat-form-field class="full-width"  appearance="outline" >
                        <mat-select [(ngModel)]="element.doctype" [ngModelOptions]="{ standalone: true }"
                        [disabled]="true"
                       > 
                        <mat-option>None</mat-option>
                           <mat-option *ngFor="let type of docListRegistration" [value]="type.code">
                             {{type.desc}}
                           </mat-option>
                         </mat-select>
                       </mat-form-field> 
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="docName" >
                    <th mat-header-cell *matHeaderCellDef >
                      {{ "DocumentUpload.documentName" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="custom-cell">
                      <input
                      type="text"
                      [(ngModel)]="element.fileDescription"
                      [disabled]="element.isUploaded"
                      (keyup)="
                        updateFiledesc($event.target.value, element, true)
                      "
                      name="fileDescription"
                      [ngModelOptions]="{ standalone: true }"
                      (input)="toUpperCase($event)"
                    />
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef >
                      {{ "DocumentUpload.fileName" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="custom-cell">
                      {{ element.fileName }}
                    </td>
                  </ng-container>
                  
                  <ng-container matColumnDef="fileType">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ "DocumentUpload.fileType" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="custom-cell">
                      <mat-form-field class="full-width"  appearance="outline" >
                      <mat-select
                        [(ngModel)]="element.docFileType"
                        [required]="true"
                        [disabled]="element.isUploaded"
                        (selectionChange)="
                          upadteFileList(element.docFileType, element, true)
                        "
                        [ngModelOptions]="{ standalone: true }"
                      >
                        <mat-option>
                          <ngx-mat-select-search
                            [formControl]="docTypeSearch"
                            [placeholderLabel]="
                              'RegistrationPage.search' | translate
                            "
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option>{{
                          "RegistrationPage.none" | translate
                        }}</mat-option>
                        <mat-option
                          *ngFor="let option of documentTypelist"
                          [value]="option.code"
                        >
                          {{ option.desc }}
                        </mat-option>
                      </mat-select>
                      </mat-form-field>
                      </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="custom-cell">
                      {{ "DocumentUpload.action" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="custom-cell">
                      <div class="center">
                        <mat-icon
                        *ngIf="element.isUploaded"
                        style="font-size: 18px"
                        [matTooltip]="'common.view' | translate"
                        (click)="viewFile(element)"
                        >remove_red_eye</mat-icon>
                        <mat-icon
                        *ngIf="element.isUploaded"
                          (click)="downloadFile(element)"
                          style="font-size: 18px"
                          matTooltip="{{
                            'DocumentUpload.downloadFile' | translate
                          }}"
                        >
                          file_download
                        </mat-icon>
                        <mat-icon
                          (click)="confirmDelete(element, true)"
                          style="font-size: 18px; color: red"
                          matTooltip="{{ 'payerInfo.removeFile' | translate }}"
                        >
                          remove_circle
                        </mat-icon>

                        
                      </div>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="fileUploadColumns; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: fileUploadColumns"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    
    <div 
      *ngIf="enableCardReaderBtn"
      appearance="outline"
      style="
        position: absolute; 
        right: 250px; 
        top: 0px; 
        width: 100px; 
        height: 36px; 
        z-index: 10;
      "
    >
      <button
        mat-flat-button
        class="btnCyan action-btn"
        data-automation-attribute="btn-card"
        (click)="checkStatus()"
      >
        Read Card
      </button>
    </div>

       <mat-form-field appearance="outline"
  style="
    position: absolute; 
    right: 0px; 
    top: 0px; 
    width: 250px; 
    height: 36px; 
    z-index: 10; 
    background-color: white;
    --mdc-outlined-text-field-outline-color: black;
    --mdc-outlined-text-field-focus-outline-color: black;
    --mdc-outlined-text-field-hover-outline-color: black;
    --mat-mdc-form-field-container-text-font: inherit;
  "
>
  <input
  matInput
    #scanInput    
  [value]="tokenValue"
  [placeholder]="'RegistrationPage.scanToken' | translate"
  (keydown.enter)="onTokenEnter(scanInput.value)"
     data-automation-attribute="text-scan-barcode" />
  <mat-icon matSuffix>gps_not_fixed</mat-icon>
</mat-form-field>
</div>
  </form>
</div>

<div
  *ngIf="patientForm"
  attr.data-automation-attribute="divFooterAction"
>
<mat-grid-list cols="10" rowHeight="50px">
  <mat-grid-tile [colspan]="1">
    <button
    class="action-btn"
    mat-button
    data-automation-attribute="btn"
    (click)="getPatientAuditTrails()"
  >
    <img
      [style.width]="'25px'"
      matTooltip="{{ 'MergeListPage.PatientAuditTrails' | translate }}"
      class="img"
      [src]="'./assets/images/email-icons/patientAudit.png'"
    /></button
  >
<button *ngIf="rePrintSlip"
    mat-button
    data-automation-attribute="btn"
    (click)="printSlip()"
  >
    <img
      [style.width]="'30px'"
      matTooltip="{{ 'EncounterListPage.print' | translate }}"
      class="img"
      [src]="'./assets/images/button-icons/printer.svg'"
    /></button></mat-grid-tile>
  <mat-grid-tile [colspan]="7"></mat-grid-tile>
  <mat-grid-tile [colspan]="2">
    <div style="margin-left: 125px;">
  <button *ngIf="!isBackAllow" class="btnOrange" mat-mini-fab type="button"  matTooltip="{{ 'payerInfo.back' | translate }}"
  (click)="transactionIncompleteDilog()">
    <mat-icon attr.data-automation-attribute="btnReset">undo
    </mat-icon>
  </button>
  &nbsp;
  <button
    *ngIf="showRegistrationDocumentUpload"
    id="Upload Document"
    (click)="fileUploadDialog(true)"
    class="btnBlue"
    mat-mini-fab
    matTooltip="{{ 'payerInfo.uploadDocument' | translate }}"
  >
    <mat-icon >backup</mat-icon>
  </button>
  &nbsp;

  <button
    *ngIf="!isRegistered"
    id="Register"
    class="btnCyan"
    mat-mini-fab
    attr.data-automation-attribute="btnSave"
    (click)="openRegisterConfirmDialog()"
    matTooltip="{{ 'payerInfo.save' | translate }}"
  >
    <mat-icon >sim_card</mat-icon>
  </button>
  </div>
  </mat-grid-tile>
  </mat-grid-list>
</div>

<div id="#encounter" *ngIf="!patientForm">
  <div *ngIf="selectedPatient" class="mt-10 div-table-encounters">
    <ng-container>
      <table
        mat-table
        [dataSource]="dataSourceEncounters"
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="VisitDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.visitDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.VisitDate}}
          </td>
        </ng-container>

        <ng-container matColumnDef="visitType">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.visitType" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.visitType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="VisitNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.visitNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.VisitNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Department">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.speciality" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.Department }}
          </td>
        </ng-container>

        <ng-container matColumnDef="DoctorName">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.doctor" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.DoctorName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="payer">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.payer" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.payer }}
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="OutstandingAmount">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.outstandingAmt" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.OutstandingAmount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="BillNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.invoiceNo" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.BillNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="BillAmount">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.billAmt" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [ngStyle]="{ 'text-align': center }"
          >
            {{ element.BillAmount }}
          </td>
        </ng-container> -->

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsEncounters; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsEncounters"
        ></tr>
      </table>

      <div class="center" *ngIf="dataSourceEncounters.data.length == 0">
        {{ "EncounterPage.noEncounters" | translate }}
      </div>
    </ng-container>
  </div>
   <div style="position: relative; display: inline-block; width: 100%;">
  <mat-tab-group class="tabGroupPersonalDetails mt-10" (selectedTabChange)="onTabChange($event)">
    <mat-tab class="tabSubPersonalDetails">
      <ng-template mat-tab-label>
        {{ "EncounterPage.encounterHeader" | translate }}
      </ng-template>
      <div class="section-grey">
        <form
          [formGroup]="formEncounter"
          #patientEncounterForm="ngForm"
          novalidate
          attr.data-automation-attribute="formUserPersonalDetails"
        >
          <div class="flex">
            <div class="col-6">
              <div class="flex">
                <div class="col-6">
                  <label class="green ml-10">{{
                    "EncounterPage.encounterDetails" | translate
                  }}</label>
                </div>
                <div class="col-6 right">
                  <mat-checkbox formControlName="visitToDepartment">
                    {{ "EncounterPage.departmentVisit" | translate }}
                  </mat-checkbox>
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-4">
                  <app-master-form-field
                    [isRequired]="true"
                    [label]="'EncounterPage.encounterType' | translate"
                    [masterName]="masterAPI.ENCOUNTER_TYPE_MASTER"
                    [formControlName]="'encounterType'"
                    [parentForm]="formEncounter"
                    [defaultValue]="encounterTypeValue"
                    (itemSelected)="getDoctorReqOnEncounterType($event);getCounsultationchrgeOnEncounterType($event)"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.Speciality/Deparment" | translate
                    }}</mat-label>
                    <mat-select
                    [disabled]="isFromAppointment"
                      [(ngModel)]="departmentValue"
                      [required]="true"
                      attr.data-automation-attribute="speciality"
                      formControlName="department"
                      (selectionChange)="getDoctorList($event, false)"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="dipartmentSearch"
                          [placeholderLabel]="'Department'"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option>{{
                        "RegistrationPage.none" | translate
                      }}</mat-option>
                      <mat-option
                        *ngFor="let option of departmentFilterList"
                        [value]="option"
                      >
                        {{ option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
               
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.appointmentSlots" | translate
                      }}</mat-label>
                    <input readonly formControlName="appointmentSlots" type="text" matInput />
                  </mat-form-field>
                </div>
                <div class="col-1">
                  <div class="divbottom">
                    <button id="Add Appointment" (click)="addAppointment()" class="btnBlack" mat-mini-fab matTooltip="{{'EncounterPage.addAppointment' | translate}}">
                      <mat-icon class="divbottom">calendar_today</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-4">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.doctor" | translate
                    }}</mat-label>
                    <mat-select
                      id="Doctor"
                      [disabled]="isFromAppointment"
                      [required]="isDepartment"
                      panelClass="doctor-option-panel"
                      attr.data-automation-attribute="encounterDoctor"
                      formControlName="doctor"
                      (scroll)="getScreenConfigurations()"
                      (selectionChange)="validationOnDoctor();getSpeciality($event)"
                    >
                      <mat-select-trigger>
                        {{ getDoctorDescription(formEncounter.get('doctor')?.value) }}
                      </mat-select-trigger>
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="doctorSearch"
                          [placeholderLabel]="'Doctor'"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option>{{
                        "RegistrationPage.none" | translate
                      }}</mat-option>
                      <mat-option
                        *ngFor="let option of doctorFilteredList"
                        [value]="option.code"
                        [matTooltip]="isSUHCOrg ? option.desc : ''"
                        matTooltipPosition="above"
                      >
                        {{ isSUHCOrg ? '[' + option.code + '] ' + option.desc : option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>{{ "EncounterPage.clinic" | translate }}</mat-label>
                      <mat-select formControlName="clinic" [required]="isClinicReqired">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="clinicSearchCtrl"
                            [placeholderLabel]="'RegistrationPage.search' | translate">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option>
                          {{ "RegistrationPage.none" | translate }}
                        </mat-option>
                        <mat-option *ngFor="let cabin of filteredCabinList | async" [value]="cabin">
                          {{ cabin.desc }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  <!-- <app-master-form-field
                    [isRequired]="isClinicReqired"
                    [label]="'EncounterPage.clinic' | translate"
                    [masterName]="masterAPI.CABIN_MASTER"
                    [formControlName]="'clinic'"
                    [parentForm]="formEncounter"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field> -->
                </div>
                <div class="col-4">
                  <app-master-form-field
                    [isRequired]="mandatoryField.encounterType"
                    [label]="'EncounterPage.cashCounter' | translate"
                    [masterName]="masterAPI.CASH_COUNTER_MASTER"
                    [formControlName]="'cashCounter'"
                    [parentForm]="formEncounter"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-8">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.encounterremarks" | translate
                    }}</mat-label>
                    <textarea
                      attr.data-automation-attribute="encounterRemark"
                      formControlName="remarks"
                      matInput
                      maxlength="100"
                   pattern="([a-zA-Z0-9-.\u0E00-\u0E7F,<>?-._[]{}|/!@#$%^&*\s]+)"
                    ></textarea>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{ "EncounterPage.queueNumber"|translate}}</mat-label>
                    <input
                          formControlName="tokenNo"
                          [(ngModel)]="tokenNoValue"
                          matInput
                          [placeholder]="'EncounterPage.queueNo' | translate"
                          (focusout)="onFocusOutEventOnKey($event.target.value)"
                        />
                  </mat-form-field>
                </div>
                <div class="col-1">
                  <div class="divbottom">
                    <button
                      id="Add Notes"
                      (click)="addInternalNotes()"
                      class="btnBlack"
                      mat-mini-fab
                      matTooltip="{{ 'AddInternalNotes.internalNotes' | translate }}" >
                      <mat-icon class="divbottom">note_add</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row mt-10" *ngIf="consultationChargesDuringvisit == 'true'">
                <div class="col-8">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{ "EncounterPage.consultationCharges"|translate}}</mat-label>
                    <input
                          formControlName="newVisitConsultationCharge"
                          matInput
                          placeholder="{{ 'EncounterPage.consultationCharges'|translate}}"
                          readonly
                        />
                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="medicalReport">
                <div class="col-6">
                  <label class="green mt-10">{{"RegistrationPage.medicalReportDetails" | translate}}</label>
                </div>

                <div class="col-12">
                  <mat-grid-list cols="12" rowHeight="70px">
                    <mat-grid-tile [colspan]="6" [rowspan]="1">
                      <app-master-form-field
                        [isRequired]="mandatoryField.encounterType"
                        [label]="'EncounterPage.reportType' | translate"
                        [masterName]="masterAPI.REPORTTYPE_MASTER"
                        [formControlName]="'reportTypeMrd'"
                        [parentForm]="formEncounter"
                        [isRequired]="medicalReport"
                        [isSubmitted]="patientEncounterForm.submitted"
                      >
                      </app-master-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="6" [rowspan]="1">
                      <mat-form-field class="full-width" appearance="outline">
                        <mat-label
                          >{{ "EncounterPage.reportReason" | translate }}
                        </mat-label>
                        <mat-select
                          formControlName="reportResonMrd"
                          [required]="medicalReport"
                        >
                          <mat-option>
                            <ngx-mat-select-search
                              [formControl]="reportResonMrdSearch"
                              [placeholderLabel]="
                                'RegistrationPage.search' | translate
                              "
                            >
                            </ngx-mat-select-search>
                          </mat-option>
                          <mat-option>{{
                            "RegistrationPage.none" | translate
                          }}</mat-option>
                          <mat-option
                            *ngFor="let reasonMaster of reportReasonFilterdList"
                            [value]="reasonMaster.code"
                          >
                            {{ reasonMaster.desc }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-grid-tile>
                  </mat-grid-list>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="flex">
                <div class="col-12">
                  <label class="green ml-10">{{
                    "EncounterPage.referralDetails" | translate
                  }}</label>
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-6">
                  <app-master-form-field
                    [label]="'EncounterPage.visitReason' | translate"
                    [masterName]="masterAPI.REASON_MASTER_QUERY"
                    [formControlName]="'visittype'"
                    [parentForm]="formEncounter"
                    [isSubmitted]="patientEncounterForm.submitted"
                    [params]="reasonCode"
                  >
                  </app-master-form-field>
                </div>
                <div class="col-6">
                  <app-master-form-field
                    [label]="'RegistrationPage.patientCategory' | translate"
                    [masterName]="masterAPI.PATIENT_CATEGORY_MASTER"
                    [formControlName]="'patientCategory'"
                    [parentForm]="formEncounter"
                    [defaultValue]="
                      selectedPatient ? selectedPatient.patientCategory : ''
                    "
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div>
              </div>
              <div class="row mt-10" *ngIf="isAppointmentHsc">
                <div class="col-4">
                  <app-master-form-field
                    [label]="'EncounterPage.referralType' | translate"
                    [masterName]="masterAPI.REFERRAL_TYPE_MASTER"
                    [formControlName]="'referralType'"
                    [parentForm]="formEncounter"
                    (itemSelected)="getReferralList($event)"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div>
                <div class="col-4">
                  <app-master-form-field
                    [label]="'EncounterPage.referral' | translate"
                    [masterName]="masterAPI.REFERRAL_MASTER"
                    [formControlName]="'referral'"
                    [parentForm]="formEncounter"
                    [params]="referralTypeCode"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div>
                <div class="col-4">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Health Package</mat-label>
                    <mat-select
                      formControlName="healthPackage"
                      (selectionChange)="pakageChecked($event.value)"
                      multiple
                    >
                      <mat-option
                        *ngFor="let package of healthPackageList"
                        [value]="package.code"
                      >
                        {{ package.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row mt-10" *ngIf="!isAppointmentHsc">
                <div class="col-6">
                  <app-master-form-field
                    [label]="'EncounterPage.referralType' | translate"
                    [masterName]="masterAPI.REFERRAL_TYPE_MASTER"
                    [formControlName]="'referralType'"
                    [parentForm]="formEncounter"
                    (itemSelected)="getReferralList($event)"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div>
                <div class="col-6" *ngIf="!isOtherReferral">
                  <app-master-form-field
                    [label]="'EncounterPage.referral' | translate"
                    [masterName]="masterAPI.REFERRAL_MASTER"
                    [formControlName]="'referral'"
                    [parentForm]="formEncounter"
                    [params]="referralTypeCode"
                    [isSubmitted]="patientEncounterForm.submitted"
                  >
                  </app-master-form-field>
                </div> 
                <div class="col-6" *ngIf="isOtherReferral">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{ 'EncounterPage.referral' | translate }}</mat-label>
                    <input  [(ngModel)]="othersReferral" matInput maxlength="50" oninput="this.value = this.value.replace(/[^a-zA-Z0-9\s\W]/g, '')"
                      [placeholder]="'EncounterPage.referral' | translate " [ngModelOptions]=" {standalone: true}" />
                  </mat-form-field>
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-6">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.reportRemark" | translate
                    }}</mat-label>
                    <textarea
                      formControlName="reportRemarks"
                      maxlength="100"
                       pattern="([a-zA-Z0-9-.\u0E00-\u0E7F,<>?-._[]{}|/!@#$%^&*\s]+)"
                      (focusout)="onFocusOutEventUpdate('PatientNotes')"
                      attr.data-automation-attribute="encounterreportRemark"
                      matInput
                    ></textarea>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.referralRemarks" | translate
                    }}</mat-label>
                    <textarea
                      formControlName="referralRemarks"
                      maxlength="100"
                      attr.data-automation-attribute="encounterreferralRemarks"
                      matInput
                     pattern="([a-zA-Z0-9-.\u0E00-\u0E7F,<>?-._[]{}|/!@#$%^&*\s]+)"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="medicalReport">
                <div class="col-6">
                  <label class="green mt-10"></label>
                </div>
                <div class="col-6">
                  <label class="green mt-10"></label>
                </div>
                <div class="col-6">
                  <label class="mt-10"></label>
                </div>
                <div class="col-2">
                  <label class="mt-2"></label>
                </div>
                <div class="col-12">
                  <mat-grid-list
                    cols="12"
                    style="margin-top: -4px"
                    rowHeight="70px"
                  >
                    <mat-grid-tile [colspan]="12" [rowspan]="1">
                      <mat-form-field class="full-width" appearance="outline">
                        <mat-label
                          >{{ "mrd.reportRemarks" | translate }}
                        </mat-label>
                        <input
                          [required]="false"
                          formControlName="reportRemarkMrd"
                          maxlength="100"
                          matInput
                          placeholder="Report Remark"
                          pattern="([a-zA-Z0-9-.\u0E00-\u0E7F,<>?-._[]{}|/!@#$%^&*\s]+)"

                        />
                      </mat-form-field>
                    </mat-grid-tile>
                  </mat-grid-list>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="flex mt-10">
          <div class="col-6">
            <label class="green mt-10">{{
              "EncounterPage.payerDetails" | translate
            }}</label>
          </div>
          <div class="col-6 right">
            <button
              id="Add Payer"
              (click)="addPayer()"
              class="btnCyan"
              mat-mini-fab
              matTooltip="{{ 'payerInfo.addPayer' | translate }}">
              <mat-icon>add</mat-icon
              >
            </button>
          </div>
        </div>

        <div class="gl-table mt-15">
          <table
            mat-table
            [dataSource]="dataSourcePayers"
            class="mat-elevation-z8"
          >
            <ng-container matColumnDef="Priority">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.priority" | translate }}
              </th>
              <td
                mat-cell
                class="center"
                *matCellDef="let element; let index = index"
              >
                <label>{{ index + 1 }}</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="PayerType">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.payerType" | translate }}
                <span class="red">*</span>
              </th>

              <td
                mat-cell
                *matCellDef="let element; let index = index"
                class="payer-info"
              >
                <mat-select
                  [(ngModel)]="element.payerTypeCode"
                  class="table-text full-width"
                  [disabled]="element.isSelf"
                  (selectionChange)="getPayerTypePayer(element.payerTypeCode,index);
                  "
                  attr.data-automation-attribute="encounterPayer{{ index }}"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="payerTypeSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option>{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let option of payerTypeList"
                    [disabled]="option.isSelf"
                    [value]="option.code"
                  >
                    {{ option.desc }} ({{ option.code }})
                  </mat-option>
                </mat-select>
              </td>
            </ng-container>
            <ng-container matColumnDef="Payer">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.payer" | translate }}
                <span class="red">*</span>
              </th>
              <td
                mat-cell
                *matCellDef="let element; let index = index"
                class="payer-info"
              >
                <mat-select
                  [(ngModel)]="element.payerCode"
                  [disabled]="element.isSelf"
                  class="table-text full-width"
                  attr.data-automation-attribute="encounterPayer{{ index }}"
                  (selectionChange)="validatePayer(element, index);getContractPayer(element.payerCode,index);
                  getTariffList(index,true);"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="payerSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option>{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let option of element.payerList"
                    [value]="option.code"
                     [matTooltip]="(option.desc + ' (' + option.code + ')').length > 40 
                ? option.desc + ' (' + option.code + ')' 
                : ''"
                matTooltipPosition="above"
                  >
                    {{ option.desc }} ({{ option.code }})
                  </mat-option>
                </mat-select>
              </td>
            </ng-container>
            <ng-container matColumnDef="Tariff">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.tariff" | translate }}
                <span class="red">*</span>
              </th>
              <td mat-cell   class="payer-info" *matCellDef="let element; let index = index">
                <mat-select
                  [(ngModel)]="element.tariffCode"
                  class="table-text full-width"
                  attr.data-automation-attribute="encounterTariff{{ index }}"
                  
                >
                <!-- [disabled]="element.isDisableTariff" -->
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="tariffSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let option of element.tariffList"
                    [value]="option.code"
                    >{{ option.desc }}</mat-option
                  >
                </mat-select>
              </td>
            </ng-container>

            <ng-container matColumnDef="Contract">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.contract" | translate }}
              </th>
              <td mat-cell  class="payer-info" *matCellDef="let element; let index = index">
                <mat-select
                  [(ngModel)]="element.contractCode"
                  class="table-text full-width"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterContract{{
                    index + 1
                  }}"
                  (selectionChange)="getTariffContract(element.contractCode,index,true);"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="contractCodeSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option>{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let option of element.contractList"
                    [value]="option.code"
                    >{{ option.desc }}</mat-option
                  >
                </mat-select>
                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="AssociatedCompany">
              <th mat-header-cell *matHeaderCellDef>
                {{ "billing.associatedCompany" | translate }}
              </th>
              <td mat-cell  class="payer-info" *matCellDef="let element; let index = index">
                <mat-select
                  [(ngModel)]="element.associatedCompanyCode"
                  class="table-text full-width"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterAssociatedCompany{{
                    index
                  }}"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="associatedCompanySearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option>{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>

                  <mat-option
                    *ngFor="let option of associatedCompanyList"
                    [value]="option.code"
                    >{{ option.desc }}</mat-option
                  >
                </mat-select>
                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="gLRefNo">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.gLRefNo" | translate }}
              </th>
              <td mat-cell   class="payer-info" *matCellDef="let element; let index = index" >
                <mat-select
                  [(ngModel)]="element.glReferenceNo"
                  (selectionChange)="glDetails(element.glReferenceNo,index,element.referralNoList,true)"
                  class="table-text full-width"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterGlType{{ index }}"
                >
                  <mat-option value="">{{"RegistrationPage.none" | translate}}</mat-option>
                  <mat-option
                    *ngFor="let option of element.referralNoList"
                    [value]="option.glrefno"
                    >{{ option.glrefno }}</mat-option
                  >
                </mat-select>
                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="GLType">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.glType" | translate }}
              </th>
              <td mat-cell   class="payer-info" *matCellDef="let element; let index = index">
                <mat-select
                  [(ngModel)]="element.glTypeCode"
                  [disabled]="true"
                  class="table-text full-width"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterGlType{{ index }}"
                >
                  <mat-option value="">{{"EncounterPage.select" | translate}}</mat-option>
                  <mat-option
                    *ngFor="let option of glTypeList"
                    [value]="option.code"
                    >{{ option.desc }}</mat-option
                  >
                </mat-select>
                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="PolicyNumber">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.policyNumber" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let element; let index = index"
                class="policy-number"
              >
                <input
                  [(ngModel)]="element.policyNumber"
                  type="text"
                  class="policy-number"
                  value=""
                  maxlength="20"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterPolicyNumber{{
                    index
                  }}"
                  pattern="[a-zA-Z0-9]+"
                />

                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="EffectiveDate">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.effectiveDate" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let element; let index = index"
                class="effective-date"
              >
                <input
                  matInput
                  [matDatepicker]="pickerEff"
                  [(ngModel)]="element.effectiveDate"
                  class="table-text full-width effective-date-input"
                  (click)="pickerEff.open()"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterEffectiveDate{{
                    index
                  }}"
                />
                <mat-datepicker #pickerEff></mat-datepicker>
                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
            <ng-container matColumnDef="expiryDate">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.glexpirydate" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let element; let index = index"
                class="effective-date"
              >
                <input
                  matInput
                  [matDatepicker]="pickerEff"
                  [(ngModel)]="element.expiryDate"
                  [disabled]="element.isexpirypayerDate"
                  class="table-text full-width effective-date-input"
                  (click)="pickerEff.open()"
                  *ngIf="!element.isSelf"
                  attr.data-automation-attribute="encounterEffectiveDate{{
                    index
                  }}"
                />
                <mat-datepicker #pickerEff></mat-datepicker>
                <label *ngIf="element.isSelf">NA</label>
              </td>
            </ng-container>
        
            <ng-container matColumnDef="glBalance">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.glBalance" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let element; let index = index"
                class="policy-number"
              >
                <input
                  [(ngModel)]="element.glAmount"
                  type="text"
                  class="policy-number"
                  value=""
                  *ngIf="!element.isSelf"
                  [disabled]="true"
                  attr.data-automation-attribute="encounterPolicyNumber{{
                    index
                  }}"
                />

                <label *ngIf="element.isSelf">NA</label>
                </td>
                </ng-container>
                <ng-container matColumnDef="Remark">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.remark" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element; let index = index">
                    <mat-form-field appearance="outline" class="remark-field full-width">
                      <textarea matInput [(ngModel)]="element.remark"></textarea>
                    </mat-form-field>
                  </td>
                </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef>
                {{ "EncounterPage.action" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let index = index" style="max-width: 120px; position: sticky;">
                <div style="display: flex;">
                <button mat-icon-button *ngIf="element.isSelf == false" (click)="removePayer(element)"
                matTooltip="{{ 'payerInfo.delete' | translate }}">
                  <mat-icon>delete
                  </mat-icon>
                </button>
                &nbsp;
                <button
                  *ngIf="element.isSelf == false"
                  (click)="changePayerPriority(true, index)"
                  class="btnCyan"
                  mat-mini-fab
                  type="button"
                >
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                &nbsp;
                <button
                  *ngIf="element.isSelf == false"
                  (click)="changePayerPriority(false, index)"
                  class="btnCyan"
                  mat-mini-fab
                  type="button"
                >
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
              </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsPayers sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumnsPayers"
            ></tr>
          </table>
        </div>
      </div>
    </mat-tab>
   
    <mat-tab class="tabSubPersonalDetails">
      <ng-template mat-tab-label>
        {{ "EncounterPage.nokDetails" | translate}}
      </ng-template>
      <div id="#referral">
        <form [formGroup]="formNextOfKin" #patientKinForm="ngForm" novalidate
          attr.data-automation-attribute="formUserPersonalDetails">
          <mat-grid-list cols="16" rowHeight="40px">
            <mat-grid-tile [colspan]="1">
              <label class="green">{{"EncounterPage.nokDetails" | translate}}</label>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="14"></mat-grid-tile>
            <mat-grid-tile [colspan]="1"  class="right">
              <button *ngIf="!isEditNok" (click)="addNextOfKin('add')" class="btnCyan" mat-mini-fab [matTooltip]="'RegistrationPage.addNextOfKin' | translate">
                <mat-icon>add</mat-icon>
              </button>
              <button *ngIf="isEditNok" (click)="addNextOfKin('update')" class="btnOrange" mat-mini-fab [matTooltip]="'RegistrationPage.saveNextOfKin' | translate">
                <mat-icon>save</mat-icon>
              </button>
            </mat-grid-tile>
          </mat-grid-list>
          <mat-grid-list cols="12" rowHeight="50px">
            <mat-grid-tile [colspan]="1">
              <app-master-form-field [label]="'RegistrationPage.prefix' | translate" [masterName]="masterAPI.PREFIX_MASTER"
                [formControlName]="'prefix'" [parentForm]="formNextOfKin" [isSubmitted]="patientKinForm.submitted"
                [defaultValue]="titleDefaultValue">
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="3">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.name" | translate
                  }}</mat-label>
                <input formControlName="name" type="text" matInput oninput="this.value = this.value.toUpperCase()"
                  maxlength="50" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <app-master-form-field [label]="'EncounterPage.relation' | translate" [masterName]="masterAPI.RELATION_MASTER"
                [formControlName]="'relation'" [parentForm]="formNextOfKin" [isSubmitted]="patientKinForm.submitted"
                [defaultValue]="relationDefaultValue">
              </app-master-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
               <mat-form-field class="full-width" appearance="outline">
                 <mat-label>{{
                  "EncounterPage.primaryID" | translate
                  }}</mat-label>
                    <mat-select [formControlName]="'identificationType'"
                      placeholder="Identification Type"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="primaryIdSearchNok"
                          [placeholderLabel]="'RegistrationPage.search' | translate"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let option of primaryIdFilteredListNok" 
                      [value]="option">
                        {{ option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.primaryDocNo" | translate
                  }}</mat-label>
                <input [required]="false" formControlName="identificationNumber" type="text" maxlength="25" matInput
                  pattern="([a-zA-Z0-9\u0E00-\u0E7F,'\-._/!@#$%^&*\s]+)" (input)="inputValidation.replaceSpaces($event)" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="2">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.phone" | translate
                  }}</mat-label>
                <input formControlName="phoneNumber" maxlength="15" type="text"  pattern="[0-9+-]+" matInput />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
    <mat-grid-list cols="12" rowHeight="50px">
      <mat-grid-tile [colspan]="2">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{
            "EncounterPage.address" | translate
            }}</mat-label>
          <input formControlName="address" type="text" maxlength="100" matInput
            pattern="([a-zA-Z0-9,'<>?-._[]{}|/!@#$%^&*\s]+)" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2">
        <app-master-form-field [label]="'EncounterPage.country' | translate" [masterName]="masterAPI.COUNTRY_MASTER"
          [formControlName]="'country'" [parentForm]="formNextOfKin" (itemSelected)="getNOKStateList($event)"
          [isSubmitted]="patientKinForm.submitted" [defaultValue]="countryDefaultValue">
        </app-master-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2">
        <app-master-form-field [label]="'EncounterPage.state' | translate" [masterName]="masterAPI.STATE_MASTER_QUERY"
          [formControlName]="'state'" [parentForm]="formNextOfKin" [params]="nokCountryCode"
          (itemSelected)="getNOKCityList($event)" [isSubmitted]="patientKinForm.submitted"
           [defaultValue]="stateDefaultValue">
        </app-master-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2">
        <app-master-form-field [label]="'EncounterPage.city' | translate" [masterName]="masterAPI.CITY_MASTER_QUERY"
          [formControlName]="'city'" [parentForm]="formNextOfKin" [params]="nokStateCode"
          [isSubmitted]="patientKinForm.submitted" (itemSelected)="getSubDistrictForNOK($event)"
           [defaultValue]="cityDefaultValue">
        </app-master-form-field>
        </mat-grid-tile>

      <mat-grid-tile [colspan]="2">
        <app-master-form-field [label]="'RegistrationPage.subArea' | translate" [masterName]="masterAPI.DIST_MASTER_QUERY"
          [formControlName]="'area'" [parentForm]="formNextOfKin" [params]="nokAreaCode"
          [isSubmitted]="patientKinForm.submitted" (itemSelected)="secondaryDistrictAreaSelected($event)"
           [defaultValue]="areaDefaultValue">
        </app-master-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{
            "EncounterPage.zipcode" | translate
            }}</mat-label>
          <input formControlName="postcode" pattern="[a-zA-Z0-9]+" type="text" maxlength="10" 
          (focusout)="getAddressByPostCode($event.target.value)" matInput />
        </mat-form-field>
      </mat-grid-tile>
       <mat-grid-tile [colspan]="1">
          <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
             <mat-checkbox 
               style="margin-left: auto; margin-right: auto;"
               [(ngModel)]="isGetAddress"
                [ngModelOptions]="{ standalone: true }"
                (change)="searchByPostCode($event)">
                {{ "RegistrationPage.search" | translate }}
              </mat-checkbox>
           </div>
         </mat-grid-tile>
      </mat-grid-list>
      <div class="gl-table mt-10">
              <table
                mat-table
                [dataSource]="dataSourceNextOfKin"
                class="mat-elevation-z8"
              >
                       
              <ng-container matColumnDef="check">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                  <mat-checkbox [checked]="element.checked" (change)="getNokforSave($event,element)"></mat-checkbox>
                </td>
              </ng-container>
                <ng-container matColumnDef="Name">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "common.nokName" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name | NameFormat}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Relation">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.relation" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      element.relation
                        ? element.relation.code
                          ? element.relation.code.desc
                          : ""
                        : ""
                    }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="IdentificationType">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.primaryID" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      element.identificationType && element.identificationType.code
                        ? element.identificationType.code.desc
                          ? element.identificationType.code.desc
                          : ""
                        : element.identificationType
                          ? element.identificationType.desc
                          : ""
                    }}
                    
                  </td>
                </ng-container>

                <ng-container matColumnDef="IdentificationNo">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.primaryDocNo" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.idNumber }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Mobile">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.phone" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.phoneNumber }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="IsGuarator">
                  <th mat-header-cell *matHeaderCellDef [style.display]="isKinGuarantorRequired ? '' : 'none'">
                    {{ "EncounterPage.isguarantor" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;" [style.display]="isKinGuarantorRequired ? '' : 'none'">
                    <mat-checkbox
                      (change)="setGuarantorValue(element , $event)"
                      [checked]="element.isGuarantor">
                    </mat-checkbox>
                  </td>
                </ng-container>
                 <ng-container matColumnDef="Address">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.address" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-icon
                      [matTooltip]="'RegistrationPage.addressDetails' | translate"
                      (click)="displayAddressDetails(element)"
                      >info</mat-icon
                    >
                  </td>
                </ng-container>

                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "EncounterPage.action" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-icon [matTooltip]="'RegistrationPage.edit' | translate" (click)="editNOK(element)">
                      edit
                    </mat-icon>
                    <mat-icon
                      matTooltip="{{ 'payerInfo.delete' | translate }}"
                      (click)="deleteNextOfKin(element)"
                      >delete</mat-icon
                    >
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsNOKs  sticky: true" ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsNOKs"
                ></tr>
              </table>

              <div *ngIf="dataSourceNextOfKin.data.length == 0" class="center">
                {{ "EncounterPage.noRecords" | translate }}
              </div>
            </div>
        </form>
      </div>
    </mat-tab>
    <!-- <mat-tab class="tabSubPersonalDetails" *ngIf="isOtherDetailsShow">
      <ng-template mat-tab-label>
        {{ "EncounterPage.otherDetails" | translate }}
      </ng-template>
      <div class="section-grey">
        <form
          [formGroup]="otherDetail"
          #patientEncounterForm="ngForm"
          novalidate
          attr.data-automation-attribute="formUserPersonalDetails"
        >
        <mat-grid-list cols="12" rowHeight="50px" >
          <mat-grid-tile [colspan]="1">
            <mat-checkbox formControlName="isPregnant" [checked]="isPregnant" >
              {{ "RegistrationPage.isPregnant" | translate }}
            </mat-checkbox>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1">
            <mat-checkbox formControlName="isLactating" [checked]="isLactating">
              {{ "RegistrationPage.isLactating" | translate }}
            </mat-checkbox>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="2">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ "RegistrationPage.LMP" | translate }}</mat-label>
              <input
                matInput
                formControlName="lmpDate"
                [max]="today"
                [matDatepicker]="picker1"
                [placeholder]="'RegistrationPage.LMP' | translate"
                attr.data-automation-attribute="LMP"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </mat-grid-tile>
          </mat-grid-list>
      </form>
      </div>
    </mat-tab> -->
    <mat-tab class="tabSubPersonalDetails" *ngIf="showRegistrationDocumentUpload">
      <ng-template mat-tab-label>
        {{ "EncounterPage.documents" | translate }}
      </ng-template>

      <input type="file" id="fileUpload" style="display: none" />
      <div class="file-table">
        <table
          mat-table
          [dataSource]="fileSource"
          class="mat-elevation-z8"
         
        >
          <ng-container matColumnDef="docType">
            <th mat-header-cell *matHeaderCellDef>
              {{ "DocumentUpload.documentType" | translate }}
              <span class="red">*</span>
            </th>
            <td mat-cell *matCellDef="let element" class="custom-cell">
              <mat-form-field class="full-width"  appearance="outline"  >
                <mat-select [(ngModel)]="element.doctype" [disabled]="element.isUploaded"
                [ngModelOptions]="{ standalone: true }"
               > 
                <mat-option>None</mat-option>
                   <mat-option *ngFor="let type of docListEncounter" [value]="type.code">
                     {{type.desc}}
                   </mat-option>
                 </mat-select>
               </mat-form-field> 
            </td>
          </ng-container>

          <ng-container matColumnDef="docName" >
            <th mat-header-cell *matHeaderCellDef>
              {{ "DocumentUpload.documentName" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="custom-cell">
              <input
              type="text"
              [(ngModel)]="element.fileDescription"
              [disabled]="element.isUploaded"
              name="fileDescription"
              pattern="[a-zA-Z0-9]+"
            />
            </td>
          </ng-container>

          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef>
              {{ "DocumentUpload.fileName" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="custom-cell">
              {{ element.fileName }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="fileType">
            <th mat-header-cell *matHeaderCellDef>
              {{ "DocumentUpload.description" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <input
                type="text"
                pattern="[a-zA-Z0-9\s]+"
                [(ngModel)]="element.fileDescription"
                (keyup)="
                  updateFiledesc(element.fileDescription, element, false)
                "
                name="fileDescription"
              />
            </td>
          </ng-container> -->

          <ng-container matColumnDef="fileType">
            <th mat-header-cell *matHeaderCellDef>
              {{ "DocumentUpload.fileType" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="custom-cell">
              <mat-form-field class="full-width"  appearance="outline"  >
              <mat-select
                [(ngModel)]="element.docFileType"
                [required]="true"
                [disabled]="element.isUploaded"
                (selectionChange)="
                  upadteFileList(element.docFileType, element, true)
                "
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="docTypeSearch"
                    [placeholderLabel]="
                      'RegistrationPage.search' | translate
                    "
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option>{{
                  "RegistrationPage.none" | translate
                }}</mat-option>
                <mat-option
                  *ngFor="let option of documentTypelist"
                  [value]="option.code"
                >
                  {{ option.desc }}
                </mat-option>
              </mat-select>
            </mat-form-field>
              </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef >
              {{ "DocumentUpload.action" | translate }}
            </th>
            <td mat-cell *matCellDef="let element" >
              <a>
                <mat-icon
                  (click)="removeFile(element, false)"
                  style="font-size: 18px; color: red"
                  matTooltip="{{ 'payerInfo.removeFile' | translate }}"
                >
                  remove_circle
                </mat-icon>
              </a>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="fileUploadColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: fileUploadColumns"></tr>
        </table>
      </div>
    </mat-tab>
    <mat-tab class="tabSubPersonalDetails"
  data-automation-attribute="tab-outstnading-bill">

  <ng-template mat-tab-label>
    <span style="display: inline-block; margin-right: 14px;">
      {{ "EncounterPage.pendingOrders" | translate }}
    </span>
    <span *ngIf="showBadge" matBadge="{{pendingOrderCount}}" matBadgeColor="warn"></span>
  </ng-template>

  <div class="example-container mat-elevation-z8 pendingOrder-table">

    <!-- Header (ONLY ONCE) -->
    <table mat-table [dataSource]="[]" class="table-css">

      <ng-container matColumnDef="isChecked">
        <th mat-header-cell *matHeaderCellDef style="width: 50px;"></th>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef style="width: 220px; padding-left: 20px;">
          {{ "DocumentUpload.description" | translate }}
        </th>
      </ng-container>

      <ng-container matColumnDef="Priority">
        <th mat-header-cell *matHeaderCellDef style="width: 80px;">
          {{ "adt.priority" | translate }}
        </th>
      </ng-container>

      <ng-container matColumnDef="Doctor">
        <th mat-header-cell *matHeaderCellDef style="width: 150px;">
          {{ "RegistrationPage.doctor" | translate }}
        </th>
      </ng-container>

      <ng-container matColumnDef="OrderDate">
        <th mat-header-cell *matHeaderCellDef style="width: 180px;">
          {{ "labPage.OrderedDate" | translate }}
        </th>
      </ng-container>

      <ng-container matColumnDef="OrderUser">
        <th mat-header-cell *matHeaderCellDef style="width: 150px;">
          {{ "EncounterPage.OrderUser" | translate }}
        </th>
      </ng-container>

      <ng-container matColumnDef="Remark">
        <th mat-header-cell *matHeaderCellDef style="width: 150px;">
          {{ "mrd.remark" | translate }}
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumnsPendingOrders"></tr>
    </table>

    <!-- GROUPED DATA -->
    <mat-accordion multi="true">
      <ng-container *ngFor="let category of objectKeys(groupedItems)">

        <!-- Category Header -->
        <div class="category-header">
          <mat-checkbox (change)="selectPending(category, $event)" [checked]="isCategory"></mat-checkbox>
          <span style="margin-left: 10px; font-weight: 500;">{{ category }}</span>
        </div>

        <!-- Data Table -->
        <table mat-table [dataSource]="groupedItems[category]" class="table-css">

          <!-- Checkbox -->
          <ng-container matColumnDef="isChecked">
            <td mat-cell *matCellDef="let element" style="width: 50px;">
              <mat-checkbox [(ngModel)]="element.isSelected"></mat-checkbox>
            </td>
          </ng-container>

          <!-- Description -->
          <ng-container matColumnDef="Description">
            <td mat-cell *matCellDef="let element" style="width: 220px; padding-left: 20px;">
              {{ element.serviceMaster.desc }}
            </td>
          </ng-container>

          <!-- Priority -->
          <ng-container matColumnDef="Priority">
            <td mat-cell *matCellDef="let element" style="width: 80px;">

              <div *ngIf="element.priorityMaster.desc == 'ROUTINE' || element.priorityMaster.desc == 'Routine'">
                <span class="span-dot-lab" style="background-color: rgb(36,36,177)">R</span>
              </div>

              <div *ngIf="element.priorityMaster.desc == 'URGENT' || element.priorityMaster.desc == 'Urgent'">
                <span class="span-dot-lab" style="background-color: rgb(36,177,36)">U</span>
              </div>

              <div *ngIf="element.priorityMaster.desc == 'STAT' || element.priorityMaster.desc == 'Stat'">
                <span class="span-dot-lab" style="background-color: rgb(229,20,20)">S</span>
              </div>

            </td>
          </ng-container>

          <!-- Doctor -->
          <ng-container matColumnDef="Doctor">
            <td mat-cell *matCellDef="let element" style="width: 150px;">
              {{ element.doctorMaster?.desc }}
            </td>
          </ng-container>

          <!-- Order Date -->
          <ng-container matColumnDef="OrderDate">
            <td mat-cell *matCellDef="let element" style="width: 180px;">
              {{ element.orderDate | date:'dd/MM/yyyy hh:mm a' }}
            </td>
          </ng-container>

          <!-- Order User -->
          <ng-container matColumnDef="OrderUser">
            <td mat-cell *matCellDef="let element" style="width: 150px;">
              {{ element.orderUser }}
            </td>
          </ng-container>

          <!-- Remark -->
          <ng-container matColumnDef="Remark">
            <td mat-cell *matCellDef="let element" style="width: 150px;">
              {{ element.remark }}
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: displayColumnsPendingOrders;"></tr>
        </table>

      </ng-container>
    </mat-accordion>

  </div>
</mat-tab>
 <mat-tab class="tabSubPersonalDetails" data-automation-attribute="tab-outstnading-bill" *ngIf="showCriticalHealthTab">
  
    <ng-template mat-tab-label>
      <span style="display: inline-block; margin-right: 14px;">{{"RegistrationPage.criticalHealthInfo" | translate}}</span>
    </ng-template>
    <div class="example-container mat-elevation-z8 pendingOrder-table" data-automation-attribute="div-worklist">
   <mat-grid-list cols="16" rowHeight="40px">
            <mat-grid-tile [colspan]="3">
             <div style="margin-right: auto;margin-left: 20px;"> <label class="green">{{"RegistrationPage.citicalHealthInfoList" | translate}}</label></div>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="12"></mat-grid-tile>
            <mat-grid-tile [colspan]="1" class="right">
               <button  class="btnCyan" mat-mini-fab (click)="addCriticalInfo()">
                <mat-icon >add</mat-icon>
              </button>
            </mat-grid-tile>
          </mat-grid-list>

      <mat-tab-group>
        <mat-tab label="Critical Health (Active)">
          <div style="overflow: auto; height: 35vh;">
          <table mat-table [dataSource]="dataSourceCriticalHeailthActive" class="mat-elevation-z1 custom-table">
  
            <!-- Condition Type -->
            <ng-container matColumnDef="conditionType">
              <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.conditionType" | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.conditionType.display }} </td>
            </ng-container>
  
            <!-- Created Date -->
            <ng-container matColumnDef="createdDate">
              <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.createdDate" | translate}} </th>
              <td mat-cell *matCellDef="let element">{{ (element.createdOn) * 1000 | date:'dd/MM/yyyy HH:mm aa' }} </td>
            </ng-container>
  
            <!-- Created By -->
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.createdBy" | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.createdBy }} </td>
            </ng-container>
  
            <!-- Clinical Health Details -->
            <ng-container matColumnDef="clinicalHealthDetails">
              <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.clinicalHealthDetails" | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button matTooltip="View Details" (click)="editCriticalHealth(element, true)">
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </ng-container>
  
            <!-- Action -->
            <ng-container matColumnDef="actionHealthDetails">
              <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.action" | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button  matTooltip="Edit" (click)="editCriticalHealth(element,false)">
                  <mat-icon>edit</mat-icon>
                </button>
  
                <button mat-icon-button matTooltip="Delete" (click)="deleteCriticalHealth(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
  
            <!-- Render Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCriticalHeailthActive;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCriticalHeailthActive;"></tr>
  
          </table></div>
        </mat-tab>
  
        <mat-tab label="Critical Health (Inactive)">
          <div style="height: 35vh; overflow: auto;">
  
            <table mat-table [dataSource]="dataSourceCriticalHeailthInactive" class="mat-elevation-z1 custom-table">
  
              <!-- Condition Type -->
              <ng-container matColumnDef="conditionType">
                <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.conditionType" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{ element.conditionType.display }} </td>
              </ng-container>

                 <!-- Clinical Health Details -->
            <ng-container matColumnDef="clinicalHealthDetails">
              <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.clinicalHealthDetails" | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button matTooltip="View Details" (click)="editCriticalHealth(element, true)">
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
            </ng-container>

              <!-- Deleted On -->
              <ng-container matColumnDef="deletedOn">
                <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.deletedOn" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{ (element.deletedOn) * 1000 | date:'dd/MM/yyyy HH:mm aa' }} </td>
              </ng-container>
  
              <!-- Inactive By -->
              <ng-container matColumnDef="inactiveBy">
                <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.inactiveBy" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{ element.deletedBy }} </td>
              </ng-container>
  
              <!-- Reason -->
              <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.reason" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{ element.reason.display }} </td>
              </ng-container>
  
              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> {{"RegistrationPage.status" | translate}} </th>
                <td mat-cell *matCellDef="let element" class="inactive">
                  {{ element.status==true?'Active':'Inactive' }}
                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumnsCriticalHeailthInactive;sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsCriticalHeailthInactive;"></tr>
  
            </table>
  
          </div>
        </mat-tab>
      </mat-tab-group>
  
    </div>
  </mat-tab>
  </mat-tab-group>
  <mat-form-field appearance="outline"
  style="
    position: absolute; 
    right: 0px; 
    top: 2px; 
    width: 250px; 
    height: 36px; 
    z-index: 10; 
    background-color: white;
    --mdc-outlined-text-field-outline-color: black;
    --mdc-outlined-text-field-focus-outline-color: black;
    --mdc-outlined-text-field-hover-outline-color: black;
    --mat-mdc-form-field-container-text-font: inherit;
  "
>
 <input
  matInput
    #scanInput    
  [value]="tokenValue" 
  [placeholder]="'RegistrationPage.scanToken' | translate"
  (keydown.enter)="onTokenEnter(scanInput.value)"
     data-automation-attribute="text-scan-barcode" /> <mat-icon matSuffix>gps_not_fixed</mat-icon>
</mat-form-field>
</div>
  <div class="section-grey" [ngClass]="{ 'dflex': isDefaultDeposit && showDefaultDeposit }">
    <mat-form-field appearance="outline" *ngIf="isDefaultDeposit && showDefaultDeposit">
      <mat-label>Default Deposit</mat-label>
      <input
            [(ngModel)]="defaultDeposit"
            matInput
            type="number"
            (input)="inputValidation.limitInputLength($event,10)"
            placeholder="Default Deposit"
          />
    </mat-form-field>
    <div class="right mt-2">
    <button
      (click)="confirmClearPatientEncounter()"
      class="btnOrange"
      mat-mini-fab
      matTooltip="{{ 'payerInfo.reset' | translate }}">
      <mat-icon>refresh</mat-icon>
    </button>
    &nbsp;
    <button *ngIf="showRegistrationDocumentUpload" id="Upload Document" (click)="fileUploadDialog(false)" class="btnBlue" mat-mini-fab
      matTooltip="{{ 'payerInfo.uploadDocument' | translate }}">
      <mat-icon>backup</mat-icon>
    </button>
    &nbsp;
    <button *ngIf="!isEncounterAllow" id="Save Encounter" (click)="openEncounterConfirmDialog()" class="btnCyan"
      mat-mini-fab matTooltip="{{ 'payerInfo.save' | translate }}">
      <mat-icon>sim_card</mat-icon>
    </button>
  </div>
  </div>
</div>
